function showCouponInput() {
	$('.orderStatus--coupon').show();
	$('#orderStatus__coupon__show').hide();
	// $('.orderStatus__couponStatus__input').focus();
}

function enableCouponRemoval() {
    $('#orderStatus__coupon__show').hide();
    $('#removeCoupon').css('display','inline-block');
	$('.orderStatus--coupon').css('margin-top', '0');
}

function disableCouponRemoval() {
    $('#orderStatus__coupon__show').show();
    $('#removeCoupon').hide();
    $('.orderStatus--coupon').hide();
	$('.orderStatus--coupon').css('margin-top', '');
}

function removeCouponRow() {

	return;
    $('.table__row').each(function(index, element) {
        var desktopElement = $(element).find('.tableCellPrice');

        desktopElement.removeClass("old");

        $('.product-price-wrapper').removeClass('w-discount');

        $(element).find('#__percentdesk').remove();
        $(element).find('#__discountres').remove();
        $(element).find('#__discountdesk').remove();
        $(element).find('.table__cell__percentage__responsive').remove();
        $('#__discountvalue').parents('.table__row').remove();
    });
}

function couponCssRemove() {
    // $('#orderStatus__coupon').parent().children('input').val("");
    $('.orderStatus__couponStatus__input').removeClass('orderStatus__couponStatus__input__success');
    $('.orderStatus__couponStatus__img').removeClass('orderStatus__couponStatus__img__success');

	disableCouponRemoval();
}

function couponCssSuccess() {
    if(!window.jstransobj) {
        window.jstransobj = { linkPrefix : "" };
    }
    $('#orderStatus__coupon').parent().children('input').removeClass('orderStatus__couponStatus__input__glow');

    $('.orderStatus__couponStatus__input').removeClass('orderStatus__couponStatus__input__fail');
    $('.orderStatus__couponStatus__img').removeClass('orderStatus__couponStatus__img__fail');

    $('.orderStatus__couponStatus__input').addClass('orderStatus__couponStatus__input__success');
    $('.orderStatus__couponStatus__img').addClass('orderStatus__couponStatus__img__success');

    $('.orderStatus__couponStatus').removeClass('orderStatus__couponStatus--false');
    $('.orderStatus__couponStatus').addClass('orderStatus__couponStatus--true');
}

function couponCssFailed() {
    $('#orderStatus__coupon').parent().children('input').removeClass('orderStatus__couponStatus__input__glow');

    $('.orderStatus__couponStatus__input').addClass('orderStatus__couponStatus__input__fail');
    $('.orderStatus__couponStatus__img').addClass('orderStatus__couponStatus__img__fail');

    $('.orderStatus__couponStatus').addClass('orderStatus__couponStatus--false');
    $('.orderStatus__couponStatus').removeClass('orderStatus__couponStatus--true');
}

function couponCssRetry() {
    $('.orderStatus__couponStatus__input').removeClass('orderStatus__couponStatus__input__success');
    $('.orderStatus__couponStatus__img').removeClass('orderStatus__couponStatus__img__success');

    $('.orderStatus__couponStatus__input').removeClass('orderStatus__couponStatus__input__fail');
    $('.orderStatus__couponStatus__img').removeClass('orderStatus__couponStatus__img__fail');
}

function couponCssAlreadyApplied(couponCode) {
    $('.orderStatus--coupon').animate({ 'opacity': '1' });
    $('.orderStatus__couponStatus__input').addClass('orderStatus__couponStatus__input__success');
    $('.orderStatus__couponStatus__img').addClass('orderStatus__couponStatus__img__success');

    $('.orderStatus__couponStatus').removeClass('orderStatus__couponStatus--false');
    $('.orderStatus__couponStatus').addClass('orderStatus__couponStatus--true');
    $('#orderStatus__coupon').parent().children('input').val(couponCode);
	couponCssSuccess();
	showCouponInput();
    enableCouponRemoval();
}
//--------------------------------------------------------------------
function highlightStockIssues() {
    $('[data-filter="productrow"]').each(function (index) {
        var $property = $(this).find('.table__cell__articleStock');
        $property.removeClass('orderStatus__stockStatus__glow-text');
        $property[0].offsetWidth = $property[0].offsetWidth;
        $property.addClass('orderStatus__stockStatus__glow-text');
    });
}

function isPaymentMethodSelected() {
    var check = false;
    $.each($('.cart__pMethods__wrapper').find('input'), function() {
        if($(this).prop('checked')) {
            check = true;
        }
    });
    return check;
}

function checkoutStepComplete(step) {
    if(window.navigator.userAgent.indexOf("Trident/") != -1) { return; }
    if(window.navigator.userAgent.indexOf("MSIE ") != -1) { return; }

    $('#circle'+step).removeClass('hidden').addClass("path circle");
    $('#check'+step).removeClass('hidden').addClass("path check");
}

function checkoutStepUncomplete(step) {
    $('#circle'+step).removeClass('path circle').addClass("hidden");
    $('#check'+step).removeClass('path check').addClass("hidden");
}

function startWithSecondStep() {

    $(".meter > span").width('34%');
    gtmServiceCheckoutStepsPush(2,""); // datalayer push
    // $('.secondStep').addClass('open').removeClass('not-opened-yet');

    adaptTableRowHeight();
    $('.secondStep__inner').css('opacity','1');
    checkoutStepComplete(1);
}

function addCustomer(object) {
    var cartId = getCookie('cart');
    $.ajax({
        cache: false,
        url: jstransobj.linkPrefix + '/customer/add',
        method: 'POST',
        data: object,
        success: function (data) {
            sibPush(cartId);
        },
        error: function (data) {
            if (typeof _errs == 'object') {
                _errs.push(new Error(data.responseText));
            }
            return;
        }
    });
}


function finishButtonContinueDeactive() {
    $('#thirdStep--check').hide();
    $('.thirdStep__continue').each(function() {
        this.style.setProperty('background', '#dbdbdb', 'important');
    });
    $('#thirdStep--load').show();

}

function finishButtonContinueActivate() {
    $('#thirdStep--load').hide();
    $('.thirdStep__continue').each(function() {
        this.style.setProperty('background', GIZZMO.__buttonActivationColor, 'important');
    });
    $('#thirdStep--check').show();
}

function validateForms() {
	var error = false;
    var objForm = {
        customer : {
            name: "",
            lastname: "",
			fname: "",
            lname: "",
            address: "",
            house_number: "",
            postal_code: "",
            city: "",
            mail: "",
            phone: "",
            notes: "",
			noteForCompany: "",
            country: "Slovenia",
            agreement: "",
            gender: ""
        },
        nonce: window.GIZZMO.__nonce ? window.GIZZMO.__nonce : 'null',
        billing: {
            name: "",
            lastname: "",
            company_name: "",
			company_tax: "",
			company_tax_country_code: $('#vat_country').val(),
			company_vies_status: null,
			company_without_tax: null,
            company_address: "",
            company_house_number: "",
            company_postal_code: "",
            company_city: ""
        },
        isBillingUsed: false,
		error : false,
		creditcard : false,
		isVatConfirmed: null,
		payment: null
    };

    if($('#newsletter').find('input').length > 0){
        $('#newsletter').find('input').prop('checked') ? objForm.customer.agreement = 1 : objForm.customer.agreement = 0;
    }else{
        objForm.customer.agreement = 1;
    }

    if($('.thirdStep__gender').css('display') == 'none') {
        objForm.customer.gender = 0;
    }
    else {
        if($('#genderM').prop('checked')) {
            objForm.customer.gender = 0;
        }
        else {
            objForm.customer.gender = 1;
        }
    }

	/* userform */
    $.each($('#thirdStep__userForm').find('input'), function (index, element) {
        if(typeof $(this).attr('name') !== "undefined") {
            objForm.customer[$(this).attr('name')] = $.trim($(this).val());

			if( $(this).attr('name') == "mail" ) {
				objForm.customer[$(this).attr('name')] = $.trim($(this).val()).replace(/\s+/g, '');
			}

			if(GIZZMO.__showFormError) {
				if( $.trim($(this).val()) == "" ) {
					$(this).addClass('input__invalid');
					error = true;

					if($('#vat_country').val().toString().toUpperCase() == "SI") {
						if(["pickup_ce", "pickup_lj", "pickupbox_ce", "pickupbox_lj"].indexOf(window.GIZZMO.__globalPostage.shipping) !== -1) {
							if( ["address", "postal_code", "city"].indexOf($(this).attr('name')) !== -1 ) {
								error = false;
								$(this).removeClass('input__invalid');
							}
						}
					}
				}

				if($( "[countypicker]" ).length > 0) {
					if($( "[countypicker]" ).val() === "-1") {
						$( ".input__county button" ).css('border-color', '#ff3535');
					}
				}

				if($( "[citypicker]" ).length > 0) {
					if($( "[citypicker]" ).val() === "-1") {
						$( ".input__city button" ).css('border-color', '#ff3535');
					}
				}
			}

        }
    });

	/* company form */
    $.each($('#thirdStep__companyForm').find('input'), function (index, element) {
        if(typeof $(this).attr('name') !== "undefined") {
			objForm.billing[$(this).attr('name')] = $.trim($(this).val());

			if(GIZZMO.__showFormError) {
				if( $('#thirdStep__companyForm').css('display') == "block" ) {
					if( $.trim($(this).val()) == "" ) {
						$(this).addClass('input__invalid');
						error = true;
					}
				}
			}
        }
    });

    /* romunija */
    if($( "[countypicker]" ).length > 0) {
        objForm.customer['house_number'] = "/";
        objForm.customer['city'] = $( "[countypicker] :selected" ).text() + ", " + $( "[citypicker] :selected" ).text();
        objForm.customer['address'] = $( "#userAddress" ).val();
        objForm.customer['postal_code'] = $( "#userPostalcode" ).val();
    }

    objForm.customer.notes = $('#userComment').val();
    objForm.customer.noteForDeliveryService = $('#userCommentForDeliveryService').val();

	if( $('#thirdStep__companyForm').css('display') == "block" ) {
		objForm.isBillingUsed = true;
		if ( $.trim($('#idddv').val()) == "" || $.trim($('#companyName').val()) == "") {
			objForm.isBillingUsed = false;
		}

		if( $('#vat_registered_checkbox').prop('checked') ) {
			objForm.billing['company_vies_status'] = window.GIZZMO.__company_vies_status;
			objForm.billing['company_without_tax'] = window.GIZZMO.__company_without_tax;
			if( $('#companyName').val() == "" || $('#companyUserAddress').val() == "" ) {
				objForm.isVatConfirmed = false;
				objForm.error = true;
				return objForm;
			}
			else {
				if(
				$('#vat_country').val().toString().toUpperCase() != "SI" &&
			    $('#vat_country').val().toString().toUpperCase() != "DE") {

					if( isShippingSameAsBilling() ) {
						vatRegisteredShippingAddress_matchSuccess();
					}
					else  {
						$('#vat-error-notice').show();
						$('#vat-error-notice').removeClass('success');
						$('html, body').animate({
							'scrollTop' : $('#vat-error-notice').offset().top - 24
						});
						objForm.error = true;

						vatRegisteredShippingAddress_matchFailed();
						return objForm;
					}
				}
			}
		}
		else {
			objForm.billing['company_vies_status'] = false;
			objForm.billing['company_without_tax'] = false;
			if( $('#companyName').val() == "" || $('#companyUserAddress').val() == "" || $('#idddv').val() == "" ) {
				objForm.error = true;
				return objForm;
			}
		}
	}

	if(error) {
		if(GIZZMO.__showFormError) {
			GIZZMO.__showFormError = false;
			$('#form-error-notice').show();

			$('html, body').animate({
				'scrollTop' : $('#form-error-notice').offset().top - 24
			});

			objForm.error = true;
			return objForm;
		}
	}

	if(GIZZMO.__globalPostage.billing == 'credit_card') {
	}

	/* Klarna */
	if(GIZZMO.__globalPostage.billing == 'klarna') {
		objForm.payment = {};
		objForm.payment.type = 'klarna';
		objForm.payment.session_id = window.GIZZMO.__klarna.session_id;
		objForm.payment.client_token = window.GIZZMO.__klarna.client_token;
		objForm.payment.authorization_token = window.GIZZMO.__klarna.authorization_token;
		objForm.payment.payment_type = window.GIZZMO.__klarna.payment_type;
	}

	objForm.error = false;

	objForm['customer']['name'] = objForm.customer.fname;
	objForm['customer']['lastname'] = objForm.customer.lname;

	return objForm;
}

function processOrder() {

	var objForm = validateForms();

	if(objForm.error === true) {
		if(objForm.isVatConfirmed == false) {
			if( $('#vat_country').val().toString().toUpperCase() != "DE" ) {
				asyncalert(jstransobj.typeAndConfirmVatNotice);
			}
			else {
				asyncalert(jstransobj.missingInformationError);
			}
		}
		else {
			asyncalert(jstransobj.missingInformationError);
		}
		return;
	}
	if(objForm.creditcard === true) { return; }

    if(GIZZMO.__blockimpatience) { return; } // če slučajno uporabnik živčen in klika na oddajo orderja
    finishButtonContinueDeactive();

	GIZZMO.__blockimpatience = 1;
	$.ajax ({
		url: jstransobj.linkPrefix + '/order/add',
		data: objForm,
		method: 'POST',
		cache: false,
		success: function (data) {
			if(data[0] == 'true' || data[0]) {
				if(data[3] == 'success_stripe'){
					location.href = jstransobj.linkPrefix + '/thankyou/payment/stripe';
				}else{
					location.href = jstransobj.linkPrefix + '/thankyou';
				}
			} else if ( (data[0] == 'false' || data[0] == false) && data[3] == 'error_stock' ){

				alert(data[1]);
				finishButtonContinueActivate();
				thirdToSecond();
				setTimeout(function() {
					refreshCart();
				},1500);

			} else if ( (data[0] == 'false' || data[0] == false) && data[3] == 'error_postage' ){

				finishButtonContinueActivate();
				alert(data[1]);
				thirdToSecond();
				changePaymentMethod();
				setTimeout(function() {
					highlightPaymentMethodSelector();
				},1500);
			} else if ( (data[0] == 'false' || data[0] == false) && data[3] == 'error_pickupbox' ){

				finishButtonContinueActivate();
				alert(data[1]);
				thirdToSecond();
				checkPickupboxAvailability();
				setTimeout(function() {
					highlightPaymentMethodSelector();
				},1500);
			}
			else {
				finishButtonContinueActivate();
				asyncalert(jstransobj.error);
			}
		},
		error: function(data) {
			GIZZMO.__blockimpatience = 0;
			finishButtonContinueActivate();
			asyncalert(jstransobj.error);
			if (typeof _errs == 'object') {
				_errs.push(new Error(data.responseText));
			}
		},
		complete: function() {
			GIZZMO.__blockimpatience = 0;
		}
	});
}

function firstToSecond() {
    gtmServiceCheckoutStepsPush(2,""); // datalayer push
    $('.firstStep').addClass("closed");
    $('.firstStep').removeClass("open");

    $('.firstStep__inner').css('opacity','.3');
    $('.firstStep__inner').slideUp(650, function() { // tu pride delay 300 za gizzmo

        $('.secondStep__inner').slideDown(450, function() {
            $('.secondStep').addClass('open').removeClass('not-opened-yet');
			$('.checkout_cross').slideDown();

            adaptTableRowHeight();
			recalculateOrderStatusPosition();
            // $('.secondStep__title').css({'padding-top': _globalStepPadding });
            $('.secondStep__inner').css('opacity','1');
            checkoutStepComplete(1);
        });
    });

	$('#secure_connection').addClass('hide');
	$('#help_notice').addClass('show');

	/* Glow highlighted additional services */
	$('.additional-service.highlight').each(function (){
		if(!$(this).hasClass('animation__glow-additional-service-highlight')){
			$(this).addClass('animation__glow-additional-service-highlight');
		}
	});

	setTimeout(function(){
		loadLottieScript();
		loadSecretBox();
	}, 500);

	gatgCheckoutCrossImpressionPush();
}

function gatgCheckoutCrossImpressionPush() {
	$(".checkout-cross-sell").each(function (index, element) {
		var obj = {
			event_category: "impression_" + $(this).data('tag'),
			event_action: "impression_checkout_cross",
			event_label: $(this).data('productId')
		};
		gatgEvent(obj);
	});
}

function secondToThird() {
    gtmServiceCheckoutStepsPush(3,""); // datalayer push
    $('.secondStep').addClass("closed");
    $('.secondStep').removeClass("open");
	
	$('.checkout_cross').slideUp();
    $('.secondStep__inner').css('opacity','0.3');
    // $('.secondStep__title').css({'padding-top': _globalStepPadding });
    $('.secondStep__inner').slideUp(950, function() {
        $('.thirdStep__inner').slideDown('slow', function() {
            $('.thirdStep').addClass('open').removeClass('not-opened-yet');

            // $('.thirdStep__title').css({'padding-top': _globalStepPadding });
            $('.thirdStep__inner').css('opacity','1');
            checkoutStepComplete(2);
        });
    });
}

function thirdToSecond() {
	checkoutStepUncomplete(2);
    $('.thirdStep').removeClass("open").addClass('not-opened-yet');

    $('.thirdStep__inner').css('opacity','0.3');
    // $('.thirdStep__title').css({'padding-top': _globalStepPadding });
    $('.thirdStep__inner').delay(550).slideUp('slow', function() {
            $('.secondStep__inner').slideDown(450, function() {
                adaptTableRowHeight();
                $('.secondStep').removeClass("closed");
                $('.secondStep').addClass("open");
				$('.checkout_cross').slideDown();

                // $('.secondStep__title').css({'padding-top': _globalStepPadding });
                $('.secondStep__inner').css('opacity','1');
            });
    });
}

function secondToFirst() {
    $('.secondStep').removeClass("open").addClass('not-opened-yet');
	$('.checkout_cross').slideUp();

    $('.secondStep__inner').css('opacity','0.3');
    // $('.secondStep__title').css({'padding-top': _globalStepPadding });
    $('.secondStep__inner').delay(550).slideUp('slow', function() {
        $('.firstStep__inner').slideDown('slow', function() {
            $('.firstStep').removeClass("closed");
            $('.firstStep').addClass("open");

            // $('.firstStep__title').css({'padding-top': _globalStepPadding });
            $('.firstStep__inner').css('opacity','1');
        });
    });

	$('#secure_connection').removeClass('hide');
	$('#help_notice').removeClass('show');
}

function thirdToFirst() {
    $('.thirdStep').removeClass("open").addClass('not-opened-yet');
    $('.secondStep').removeClass("closed").addClass('not-opened-yet');

    // $('.thirdStep').css({'background': 'rgba(246, 246, 246, 0.26)'});
    $('.thirdStep__inner').css('opacity','0.3');
    // $('.thirdStep__title').css({'padding-top': _globalStepPadding });
    $('.thirdStep__inner').delay(550).slideUp('slow', function() {
        $('.firstStep__inner').slideDown('slow', function() {
            $('.firstStep').removeClass("closed");

            // $('.firstStep__title').css({'padding-top': _globalStepPadding });
            $('.firstStep__inner').css('opacity','1');
        });
    });

	$('#secure_connection').removeClass('hide');
	$('#help_notice').removeClass('show');
}


function updateBottomOrderInfo() {
    var $finalPaymentInfo = $('.cart__pMethods--active');
	var $finalDeliveryInfo = $('.cart__store--active');

    if($finalPaymentInfo.length > 0) {
		if($('.final-shipping-info .payment').length) {
			if($finalDeliveryInfo.length > 0) {
				$('.final-shipping-info .payment').html($finalPaymentInfo.data('pickup-text').replace('%finalPrice%', $('#grandTotal').text() ));
				if(window.jstransobj.locale == "hr") {
					$('.final-shipping-info .payment').html($finalPaymentInfo.data('pickup-text').replace('%finalPrice%', $('#grandTotal').text() + " " + $('#grandTotalInEur').text() ));
				}
			} else {
				$('.final-shipping-info .payment').html($finalPaymentInfo.data('text').replace('%finalPrice%', $('#grandTotal').text() ));
				if(window.jstransobj.locale == "hr") {
					$('.final-shipping-info .payment').html($finalPaymentInfo.data('text').replace('%finalPrice%', $('#grandTotal').text() + " " + $('#grandTotalInEur').text() ));
				}
			}
		}
    }

	if($finalDeliveryInfo.length > 0) {
		if($('.final-shipping-info .delivery').length) {
			$('.final-shipping-info .delivery').html($finalDeliveryInfo.data('text'));
		}
	} else {
		if($('.cart__header__left.cart__header--active').length) {
			$('.final-shipping-info .delivery').html($('.cart__header__left.cart__header--active').data('text'));
		}
	}
}

function updateFormTexts() {
	var $thirdStepShippingText = $('.thirdStep__text.shipping');
	var $phoneInputDescriptionLabel = $('.input__phone .input-description-label');

	if(["pickup_ce", "pickup_lj"].indexOf(window.GIZZMO.__globalPostage.shipping) !== -1) {
		$thirdStepShippingText.html($thirdStepShippingText.data('pickupText'));
		$phoneInputDescriptionLabel.html($phoneInputDescriptionLabel.data('pickupText'));
	} else if(["pickupbox_ce", "pickupbox_lj"].indexOf(window.GIZZMO.__globalPostage.shipping) !== -1) {
		$thirdStepShippingText.html($thirdStepShippingText.data('pickupBoxText'));
		$phoneInputDescriptionLabel.html($phoneInputDescriptionLabel.data('pickupBoxText'));
	} else {
		$thirdStepShippingText.html($thirdStepShippingText.data('shippingText'));
		$phoneInputDescriptionLabel.html($phoneInputDescriptionLabel.data('shippingText'));
	}
}

function highlightPaymentMethodSelector() {
    $('body, html').animate({
        scrollTop : $('#cart').offset().top - 40
    });
    $('#cart').addClass('glow');
    setTimeout(function() {
        $('#cart').removeClass('glow');
    }, 4000);
}

function deactivateButton() {
    $(this).find('.firstStep__continue__cart').hide();
    $(this).find('.firstStep__continue__load').show();
    //this.style.setProperty('border', '2px solid #dbdbdb', 'important');
    this.style.setProperty('background', '#dbdbdb', 'important');
}

function activateButton() {
    $(this).find('.firstStep__continue__load').hide();
    $(this).find('.firstStep__continue__cart').show();
    //this.style.setProperty('border', '2px solid #6ec93e', 'important');
    this.style.setProperty('background', '');
}
function passwordShow(width, animationType) {
    if(animationType) {
        $('#input__wrapper').stop().animate({'opacity': '0'}, {
            queue: false,
            complete: function() {
                $('#firstStep__email').css('width', width);
                $('#firstStep__password').css({'display': 'inline-block', 'width': width, 'opacity': '1'});
                $('#firstStep__email').children('input').attr('placeholder','E-mail naslov');
                $('#input__wrapper').animate({'opacity': '1'});
            }
        });
    }
    else {
        $('#firstStep__password').slideDown();
    }
    $('#firstStep__password').children('input').prop('disabled',false);

    $('#registered').fadeOut('fast', function () {
        $('#quickBuy').fadeIn('fast');
    });
    $('#quickBuy__title').hide();
    $('#registered__title').show();
}

//--------------------------------------------------------------------
function passwordHide(animationType) {
    if(animationType) {
        $('#firstStep__password').children('input').val("");
        $('#firstStep__password').stop().animate({'opacity': '0'}, function() {
            $('#firstStep__password').css('display','none');
            $('#firstStep__password').children('input').prop('disabled',true);
        });
    }
    else {
        $('#firstStep__password').slideUp();
        $('#firstStep__password').children('input').val("");
    }

    $('#quickBuy').fadeOut('fast', function() {
        $('#registered').fadeIn('fast');
    });
    $('#registered__title').hide();
    $('#quickBuy__title').show();

    $('#firstStep__email').stop().delay(500).animate({'width': '100%'});
}

/*----------------------------------------------------------------------*/
/**
 * Klarna open session
 */
function initKlarna() {
	if(!window.jstransobj) {
		window.jstransobj = { linkPrefix : "" };
	}
	window.GIZZMO.__klarna = {};
	window.GIZZMO.__klarna.status = false;
	window.GIZZMO.__klarna.init = true;
	window.GIZZMO.__klarna.firstActive = false;

	window.GIZZMO.__klarna.session_id = null;
	window.GIZZMO.__klarna.client_token = null;
	window.GIZZMO.__klarna.payment_method_categories = null;
	window.GIZZMO.__klarna.default_selected = '';

	toggleLoadingAnimation("klarna");

	GIZZMO.__klarnaAjax = $.ajax ({
		url: jstransobj.linkPrefix + '/klarna/init',
		method: 'POST',
		cache: false
	}).done(function(data){
		if(data.status === true){
			window.GIZZMO.__klarna.session_id = data.data.session_id;
			window.GIZZMO.__klarna.client_token = data.data.client_token;
			window.GIZZMO.__klarna.payment_method_categories = data.data.payment_method_categories;

			$('.klarna .klarna__container').html(data.form);

			Klarna.Payments.init({
				client_token: window.GIZZMO.__klarna.client_token
			});

			var paymentMethodCategoriesLength = window.GIZZMO.__klarna.payment_method_categories.length;
			if(paymentMethodCategoriesLength < 1){
				window.GIZZMO.__klarna.init = false;
				thirdToSecond();
				setTimeout(function() {
					asyncalert(jstransobj.klarnaSessionError);
					highlightPaymentMethodSelector();
				},1200);
			}else{
				for(var i = 0; i < paymentMethodCategoriesLength; i++){
					var paymentCategoryData = window.GIZZMO.__klarna.payment_method_categories[i];
					var headerElement = $('.klarna-payment.' + paymentCategoryData['identifier'] + ' .klarna_selector_header .innerHeader');
					/* Header */
					headerElement.find('.title').html(paymentCategoryData['name']);

					/* Data */
					$('.klarna-payment.' + paymentCategoryData['identifier']).addClass('visible');
					if(window.GIZZMO.__klarna.default_selected === paymentCategoryData['identifier']){
						$('.klarna-payment.' + paymentCategoryData['identifier']).addClass('active');
						$('.klarna-payment.' + paymentCategoryData['identifier'] + ' .klarna_selector_content').slideDown();
						window.GIZZMO.__klarna.firstActive = true;
					}

					Klarna.Payments.load({
						container: '.klarna-payment.' + paymentCategoryData['identifier'] + ' .klarna_selector_content',
						payment_method_category: paymentCategoryData['identifier'],
						color_text: '#78797A',
						color_border: '#BABBBC',
						color_border_selected: '#23D8D8',
						radius_border: '4px'
					},
					function (res) {
						if(res.show_form === true){
							window.GIZZMO.__klarna.status = true;
							window.GIZZMO.__klarna.init = false;
						}
					});
				}

				if(window.GIZZMO.__klarna.firstActive === false){
					var firstChild = $('#klarna-payments-container .klarna-payment').first();
					if(firstChild.length > 0){
						firstChild.addClass('active');
						firstChild.find('.klarna_selector_content').slideDown();
					}

				}

				toggleLoadingAnimation("klarna");
			}
		}else{
			window.GIZZMO.__klarna.init = false;
			thirdToSecond();
			setTimeout(function() {
				asyncalert(jstransobj.klarnaSessionError);
				highlightPaymentMethodSelector();
			},1200);
		}
	}).fail(function() {
		window.GIZZMO.__klarna.init = false;
		thirdToSecond();
		setTimeout(function() {
			asyncalert(jstransobj.klarnaSessionError);
			highlightPaymentMethodSelector();
		},1200);
	}).always(function(){
		/**/
	});
}

/**
 * Klarna authorize
 * @param callback
 */
function authKlarna(callback){
	var responseData = {};
	responseData.status = false;
	responseData.data = {};

	/* Fields list */
	var mapFields = {};
	mapFields.given_name = "#userName";
	mapFields.family_name = "#userSurname";
	mapFields.email = "#userEmail";
	mapFields.street_address = "#userAddress";
	mapFields.postal_code = "#userPostalcode";
	mapFields.city = "#userCityhall";
	mapFields.phone = "#userGsm";

	/* Billing address */
	var billing_address = {};
	billing_address.given_name = $('#userName').val();
	billing_address.family_name = $('#userSurname').val();
	billing_address.email = $('#userEmail').val();
	billing_address.street_address = $('#userAddress').val();
	billing_address.postal_code = $('#userPostalcode').val();
	billing_address.city = $('#userCityhall').val();
	billing_address.phone = $('#userGsm').val();
	billing_address.country = "DE";

	/* Get data */
	GIZZMO.__klarnaAjax = $.ajax ({
		url: jstransobj.linkPrefix + '/klarna/get/data/cart',
		method: 'POST',
		data: {'billing_address': billing_address},
		cache: false
	}).done(function(data){

		var payment_method_objects = $('.klarna-payment.active');
		window.GIZZMO.__klarna.payment_type = 'pay_later';
		if(payment_method_objects.length > 0){
			window.GIZZMO.__klarna.payment_type = payment_method_objects.first().data('type');
		}


		Klarna.Payments.authorize({payment_method_category: window.GIZZMO.__klarna.payment_type}, data, function(res) {
			if(res.approved === false){
				if(typeof res.error !== "undefined"){
					if(res.error.invalid_fields.length > 0){
						for(var i = 0; i < res.error.invalid_fields.length; i++){
							var invalidField = res.error.invalid_fields[i].replace("billing_address.", "");
							if(typeof mapFields[invalidField] !== "undefined"){
								$(mapFields[invalidField]).removeClass('input__valid');
								$(mapFields[invalidField]).addClass('input__invalid');
							}
						}
					}
				}
				/* Custom handle empty phone number */
				if($(mapFields['phone']).val() === ""){
					$(mapFields['phone']).removeClass('input__valid');
					$(mapFields['phone']).addClass('input__invalid');
				}

			}else{
				responseData.status = true;
			}
			responseData.data = res;

			callback(responseData);
		});

	}).fail(function(){
		callback(responseData);
	}).always(function(){});
}
/*----------------------------------------------------------------------*/
/**
 *	Stripe 
 */
function initStripe(){
	if(!window.jstransobj) {
		window.jstransobj = { linkPrefix : "" };
	}

	window.GIZZMO.__stripe = {};
	window.GIZZMO.__stripe.status = false;
	window.GIZZMO.__stripe.init = false;
	window.GIZZMO.__stripe.instance = null;
	window.GIZZMO.__stripe.cardElement = null;

	/* First get Intent customer Id */
	GIZZMO.__klarnaAjax = $.ajax ({
		url: jstransobj.linkPrefix + '/stripe/init',
		method: 'POST',
		cache: false
	}).done(function(data){
		if(data.status === true && data.client_secret !== null && data.client_secret.length > 0){
			$('#stripe-form').attr('data-secret', data.client_secret);

			window.GIZZMO.__stripe.instance = Stripe(data.public_key, {
				locale: 'sl'
			});
			var elements = window.GIZZMO.__stripe.instance.elements();
			var style = {
				base: {
					color: "#32325d",
					fontSmoothing: "antialiased",
					fontSize: "16px",
					"::placeholder": {
					color: "#aab7c4"
					}
				},
				invalid: {
					color: "#fa755a",
					iconColor: "#fa755a"
				},
			};
			window.GIZZMO.__stripe.cardElement = elements.create('card'/*, {style: style}*/);
			window.GIZZMO.__stripe.cardElement.mount('#card-element');

			window.GIZZMO.__stripe.init = true;
		}else{
			asyncalert(jstransobj.error);
			highlightPaymentMethodSelector();
		}
	}).fail(function(){
		asyncalert(jstransobj.error);
		highlightPaymentMethodSelector();
	});

}

function confirmStripe(callback){
	var responseData = {};
	
	var customerName = $('#companyUserName').val();
	if(customerName === "" || typeof customerName == "undefined"){
		customerName = $('#userName').val();
	}
	console.log(customerName);
	
	callback(responseData);
	var cardholderName = document.getElementById('cardholder-name');
	var setupForm = document.getElementById('stripe-form');
	var clientSecret = setupForm.dataset.secret;

	window.GIZZMO.__stripe.instance.confirmCardSetup(
		clientSecret,
		{
		payment_method: {
			card: window.GIZZMO.__stripe.cardElement,
			billing_details: {
			name: cardholderName,
			},
		},
		}
	).then(function(result) {
		if (result.error) {
			asyncalert(result.error.message);
		} else {
			callback(result);		
		}
	});
}

/*----------------------------------------------------------------------*/
// paypal braintree initiation
function initPaypal() {
    if(!window.jstransobj) {
        window.jstransobj = { linkPrefix : "" };
    }
    if(GIZZMO.__checkout) { return; } // če smo že pridobili hosted fielde, ne smemo klicati še enkrat
    GIZZMO.__payPalAjax = $.ajax ({
       url: jstransobj.linkPrefix + '/braintree/token',
       method: 'POST',
	   data: { 'billingType': 'paypal' },
       success: function(token) {
           //inicializacija paypala s tokenom
      	   braintree.setup(token, "custom", {
      	       onReady: function(integration) {
      	           GIZZMO.__checkout = integration;
      	           GIZZMO.__waitinitialization = 0;
      	           $('.paypalPick__ring').fadeOut(function() {
      	               $('.paypalPick__left').fadeIn();
      	           });
      	       },
      	       onPaymentMethodReceived: function(obj) {
      	           $('.paypalPick__left').fadeOut(function() {
      	               $('#paypalPick__email').html(obj.details.email);
      	               $('.paypalPick__auth').fadeIn();
      	               activateButton.call($('.secondStep__continue')[0]);
      	           });
      	           GIZZMO.__nonce = obj.nonce;
      	       },
      	       paypal: {
      	           /*singleUse: true,*/
      	           headless: true
      	           //id: 'paypalPick'
      	       }
      	   });

		   // braintree.client.create({
		   //     authorization: token
		   // }, function(clientErr, clientInstance) {
		   //     braintree.paypalCheckout.create({
		   //         client: clientInstance
		   //     }, function(paypalCheckoutErr, paypalCheckoutInstance) {
		   //         if (paypalCheckoutErr) {
		   //             console.error('Error creating PayPal Checkout:', paypalCheckoutErr);
		   //             return;
		   //         }
		   //
			// 	   GIZZMO.__checkout = paypalCheckoutInstance;
		   //         paypalCheckoutInstance.loadPayPalSDK({
		   //             // Add your config options here
			// 		   currency: 'EUR',
			// 		   intent: 'authorize',
		   //         }, function() {
			// 		    $('.paypalPick__ring').fadeOut(function() {
			// 				$('#paypalRenderBox').fadeIn();
			// 			});
		   //             paypal.Buttons({
			// 			   fundingSource: paypal.FUNDING.PAYPAL,
			// 			   style: {
			// 			     layout:  'vertical',
			// 			     color:   'blue',
			// 			     shape:   'rect',
			// 			     label:   'pay'
			// 			 	},
		   //                 createOrder: function() {
		   //                     return paypalCheckoutInstance.createPayment({
		   //                         // Include your PayPal options here. For available options, see
		   //                         // http://braintree.github.io/braintree-web/current/PayPalCheckout.html#createPayment
			// 					   flow: 'checkout',
			// 				       amount: $('#cart_product_summary_table').data('cartSumFinal'),
			// 					   currency: window.jstransobj.currency,
		   //                     });
		   //                 },
		   //
		   //                 onApprove: function(data, actions) {
		   //                     return paypalCheckoutInstance.tokenizePayment(data, function(err, payload) {
		   //                         // Submit `payload.nonce` to your server
			// 				       GIZZMO.__nonce = payload.nonce;
			// 					   $('#paypalRenderBox').fadeOut(function() {
			// 	                       $('#paypalPick__email').html(payload.details.email);
			// 	                       $('.paypalPick__auth').fadeIn();
			// 	                       activateButton.call($('.secondStep__continue')[0]);
			// 	                   });
		   //                     });
		   //                 },
			// 			   onCancel: function () {
			// 				 // teardownPaypal();
			// 		       },
		   //
			// 		       onError: function (err) {
			// 		       }
		   //             }).render('#paypalRenderBox').then(function() {
		   //                 // The PayPal button will be rendered in an html element with the ID
		   //                 // `paypal-button`. This function will be called when the PayPal button
		   //                 // is set up and ready to be used.
		   //             });
		   //         });
		   //     });
		   // });
       }
    })
}
//----------------------------------------------------------------------
// CreditCard braintree initiation
// function initCreditCard() {
//     if(!window.jstransobj) {
//         window.jstransobj = { linkPrefix : "" };
//     }
//     activateButton.call($('.secondStep__continue')[0]);
//     if(GIZZMO.__checkout) { return; } // če smo že pridobili hosted fielde, ne smemo klicati še enkrat
//
//     $('#creditCard').show();
//     GIZZMO.__waitinitialization = 1;
//
//     GIZZMO.__creditCardAjax = $.ajax({
//        url: jstransobj.linkPrefix + '/braintree/token',
//        method: 'POST',
//        cache: false,
//        success: function(token) {
//             braintree.setup(token, 'custom', {
//                 id: 'secureCreditCard',
//                 hostedFields: {
//                     number: {
//                         selector: '#number',
//                         placeholder: jstransobj.creditCardNumber
//                     },
//                     expirationDate: {
//                         selector: '#expirationDate',
//                         placeholder: jstransobj.creditCardDate
//                     },
//                     cvv: {
//                         selector: '#cvv',
//                         placeholder: 'CVV'
//                     },
//                     styles: {
//                         'input': {
//                             'font-size': '16px',
//                             'color': '#3A3A3A',
//                             'font-family': 'courier'
//                         },
//                         ':focus': {
//                             'color': '#000000'
//                         },
//                         '.valid': {
//                             'color': '#6DC93E'
//                         },
//                         '.invalid': {
//                             'color': '#F03545'
//                         }
//                     },
//                     onFieldEvent: function(event) {
//                         if(event.isEmpty) {
//                             creditCardPlaceholderAnimationHide(event.target.fieldKey);//animiranje placeholderja
//                         }
//                         else {
//                             creditCardPlaceholderAnimationShow(event.target.fieldKey);//animiranje placeholderja
//                         }
//
//                         if(event.type === 'focus') {
//                             //handle focus
//                         }
//                         else if(event.type === 'blur') {
//                             //handle blur
//                         }
//                         else if(event.type === 'fieldStateChange') {
//                             if(!event.isValid) {
//                                 var card = $('#number');
//                                 card.removeClass('creditCard__cardNumber--visa');
//                                 card.removeClass('creditCard__cardNumber--discover');
//                                 card.removeClass('creditCard__cardNumber--master-card');
//                                 card.removeClass('creditCard__cardNumber--american-express');
//                                 card.removeClass('creditCard__cardNumber--diners-club');
//                             }
//
//                             if(event.card) {
//                                 //console.log(event.card.type);
//                                 $('#number').addClass('creditCard__cardNumber--'+event.card.type);
//                             }
//                         }
//                     }
//                 },
//                 onPaymentMethodReceived: function (obj) {
//                     GIZZMO.__nonce = obj.nonce;
//                     GIZZMO.__blockimpatience = 0;
//                     GIZZMO.__waitinitialization = 0;
//                     processOrder();
//                 },
//                 onReady: function(integration) {
//                     GIZZMO.__checkout = integration;
//                     GIZZMO.__waitinitialization = 0;
//                     GIZZMO.__blockimpatience = 0;
//                     $('#creditCard--container').animate({'opacity' : '1'}, function() {
//                         $('#creditCard__loading').hide();
//                     });
//                     $('#changeMethod2').animate({'opacity' : '1'});
//                 },
//                 onError: function (obj) {
//                     if(GIZZMO.__showCreditCardError) {
//                         GIZZMO.__showCreditCardError = false;
//
//                         if(obj.type === 'VALIDATION') {
//                             finishButtonContinueActivate();
//                             asyncalert(jstransobj.ccValidateError);
//                         }
//                         else {
//                             finishButtonContinueActivate();
//                             asyncalert(jstransobj.serverError);
//                         }
//
//                         $('html, body').animate({
//                             scrollTop : $('#creditCard--container').offset().top
//                         })
//                     }
//                     else {
//                         processOrder();
//                     }
//                 }
//             });
//         }
//     });
// }
//----------------------------------------------------------------------
// reinitiation function kadar stranke želi prekiniti povezavo
function reinitiatePaypal() {
    $('.paypalPick__auth').fadeOut(function() {
        $('.paypalPick__ring').fadeIn(function () {
            if(GIZZMO.__checkout) {
                GIZZMO.__checkout.teardown(function() {
                    GIZZMO.__checkout = null;
                    GIZZMO.__nonce = null;
                    GIZZMO.__waitinitialization = 0;
                    initPaypal();
                });
            }
        });
    });
}
//----------------------------------------------------------------------
// Teardown, kadar uporabnik izbere drugo metodo plačila
function teardownPaypal() {
    if (GIZZMO.__payPalAjax != null){
        GIZZMO.__payPalAjax.abort();
        GIZZMO.__payPalAjax = null;
    }

    $('.paypalPick__left').css('display','none');
    $('.paypalPick__auth').css('display','none');
    $('.paypalPick__ring').css('display','block');
    // $('#paypalRenderBox').hide();//newpaypalintegration

    if(GIZZMO.__checkout) {
        GIZZMO.__checkout.teardown(function() {
            GIZZMO.__checkout = null;
            GIZZMO.__nonce = null;
            GIZZMO.__waitinitialization = 0;
        });
    }
    GIZZMO.__checkout = null;
    GIZZMO.__nonce = null;
}
//----------------------------------------------------------------------
// Teardown, kadar uporabnik izbere drugo metodo plačila
// function teardownCreditCard() {
//     if (GIZZMO.__creditCardAjax != null){
//         GIZZMO.__creditCardAjax.abort();
//         GIZZMO.__creditCardAjax = null;
//     }
//
//     if(GIZZMO.__checkout) {
//         GIZZMO.__checkout.teardown(function() {
//             GIZZMO.__checkout = null;
//             GIZZMO.__nonce = null;
//             GIZZMO.__waitinitialization = 0;
//         });
//     }
//     GIZZMO.__checkout = null;
//     GIZZMO.__nonce = null;
//     $('#creditCard').hide();
//     $('#creditCard--container').css('opacity', '0.1');
//     $('#changeMethod2').css('opacity', '0.1');
//     $('#creditCard__loading').show();
// }


function changePaymentMethod(flag) { // potrebujemo funkcijo, da lahko kličemo menjavo pri paypalu in kreditni kartici
	$('.cart__payment-christmas-notice').show();
	$('.cart__turbo-notice').show();

	if (typeof flag === 'undefined') {
		flag = null;
	}

	$('.cart__pMethods__prevzem').removeClass('no-border');
	$('.cart__pMethods').removeClass('no-border-radius');
	$('#changeMethod').hide();
    hideMoneySavingNotice();
    window.GIZZMO.__globalPostage.billing = '';
    deactivateButton.call($('.secondStep__continue')[0]);

    // $('.cart__pMethods__wrapper').slideUp(function() {
    // });
	var children = $('.cart__pMethods__wrapper').children();
	var element = $('.cart__pMethods__wrapper');
	children.css('bottom','0');
	children.removeClass("scaleOut cart__pMethods--active");
	children.find('input').prop('checked', false);

	//skrijemo paypal
	$('#paypalPick').slideUp(function() {
		element.css('height', GIZZMO.__paymentMethodWrapperHeight);

		if(flag !== null && flag == 'hidePaymentMethods') {
			$('#paymentMethods').slideUp();
		}
	});

    teardownPaypal(); // če ima uporabnik izbrano opcijo paypala, še to počistimo
	$('.where-to-pay-info').hide();
}

function changePickupMethod() {
	$('#pickStore').slideUp(function() {
		var children = $(this).children();
		var element = $(this);
		children.css('bottom','0');
		children.removeClass("scaleOut cart__store--active");
		children.find('input').prop('checked', false);
		element.css('height', GIZZMO.__storeWrapperHeight);
		element.stop().slideDown();
		$('.cart__pMethods__prevzem').find('input').attr('billing', '');
		window.GIZZMO.__globalPostage.shipping = "";
	});
}

function resetPickupMethod() {
	// moramo resetirati izbire lokacije, saj se s tem updejta poštni strošek
    $('#pickStore').slideUp(function() {
        var children = $(this).children();
        var element = $(this);
        children.css('bottom','0');
        children.removeClass("scaleOut cart__store--active");
        children.find('input').prop('checked', false);
        if(GIZZMO.__storeWrapperHeight) {
            element.css('height', GIZZMO.__storeWrapperHeight);
        }
    });
}

function resetTurboMethod() {
	$('#turboShipping').slideUp(function() {
		var children = $(this).children();
		var element = $(this);
		var turboNoticeHeight = 0;
		children.css('bottom','0');
		children.removeClass("scaleOut cart__store--active");
		children.find('input').prop('checked', false);
		if($('#turboShipping').find('.cart__turbo-notice').length) {
			turboNoticeHeight = GIZZMO.__turboNoticeHeight;
		}
		if(GIZZMO.__storeWrapperHeight) {
			element.css('height', GIZZMO.__storeWrapperHeight + turboNoticeHeight);
		}
		// $('.cart__pMethods__prevzem').find('input').attr('billing', '');
		// window.GIZZMO.__globalPostage.shipping = "";
	});
}

function changeTurboMethod() {
	$('#turboShipping').slideUp(function() {
		var children = $(this).children();
		var element = $(this);
		var turboNoticeHeight = 0;
		children.css('bottom','0');
		children.removeClass("scaleOut cart__store--active");
		children.find('input').prop('checked', false);
		if($('#turboShipping').find('.cart__turbo-notice').length) {
			turboNoticeHeight = GIZZMO.__turboNoticeHeight;
		}
		element.css('height', GIZZMO.__storeWrapperHeight + turboNoticeHeight);
		element.stop().slideDown();
		$('.cart__pMethods__prevzem').find('input').attr('billing', '');
		window.GIZZMO.__globalPostage.shipping = "";
	});
}

function gtmServiceCartQuantityChangePush(cartitemid, quantity, previousQuantity) {
    if(!window.jstransobj) {
        window.jstransobj = { linkPrefix : "" };
    }
    var newQuantity;
    if(previousQuantity < quantity) {
        newQuantity = quantity - previousQuantity;
    }
    else {
        newQuantity = previousQuantity - quantity;
    }
    $.ajax ({
        url: jstransobj.linkPrefix + '/gtm/getobject/'+cartitemid,
        method: 'GET',
        cache: false,
        success: function (data) {
            var rmOrAdd = {};
            if(previousQuantity < quantity) {
                // moramo spremeniti in pripraviti nov objekt, če je dodal, ker serverside dobimo pripravljenga za brisat
                newQuantity = quantity - previousQuantity;
                rmOrAdd.ecommerce = {};
                rmOrAdd.event = 'addToCart';
                rmOrAdd.ecommerce.add = {};
                rmOrAdd.ecommerce.add.products = data.ecommerce.remove.products;
                rmOrAdd.ecommerce.add.products.quantity = newQuantity;
            }
            else {
                newQuantity = previousQuantity - quantity;
                data.ecommerce.remove.products.quantity = newQuantity;
                rmOrAdd = data;
            }
            dataLayer.push(rmOrAdd);
        },
        error: function(data) {
            if(typeof _errs == 'object') {
                _errs.push(new Error(data.responseText));
            }
        }
    });
}

function removeCart() {
    var cartId = getCookie('cart');
	$.ajax({
        url: jstransobj.linkPrefix + '/cart/clear',
        method: 'POST',
        cache: false,
        xhrFields: {
            withCredentials: true
        },
        success: function (data) {
            sibPush(cartId);
            location.reload();
        },
        error: function (data) {
            if (typeof _errs == 'object') {
                _errs.push(new Error(data.responseText));
            }
        },
        complete: function() {

        }
    });
}

function removeArticleFromCart(elementId) {
    if(!window.jstransobj) {
        window.jstransobj = { linkPrefix : "" };
    }
    var cartId = getCookie('cart');
    $.ajax ({
        url: jstransobj.linkPrefix + '/cart/remove/item',
        data: {id: elementId},
        method: 'POST',
        cache: false,
        success: function (data) {

			$('#product-'+elementId).fadeOut(function() {
				$(this).remove();

				if(Object.keys(data).length == 0){
					location.reload();
				} else {

					var isProductPresent = false;
					$('[data-filter="productrow"]').each(function (index, el) {
						if( ['product_fast_shipping','product_warranty', 'product_eco_packaging'].indexOf($(el).data('productType')) == -1 ) {
							isProductPresent = true;
							return false;
						}
					});

					if(!isProductPresent) {
						removeCart();
						return;
					} else {
						refreshCart();
					}
				}
			});

			sibPush(cartId);
        },
        error: function(data) {
            if(typeof _errs == 'object') {
                _errs.push(new Error(data.responseText + "~~~~" + getCookie("cart")));
            }
        },
        complete: function() {
            // toggleLoadingAnimation("tables_wrapper", []);
        }
    });
}

function updateCartFields(cartObj) {
	checkPickupboxAvailability();
	$('#tables_wrapper').replaceWith(cartObj['render_html']);
	moveQuantitySelector();

    updateGifts(cartObj);
    productStockStatusHandler(cartObj);
	couponHandler(cartObj);
	additionalServicesHandler(cartObj);

    recalculateOrderStatusPosition();
	updateBottomOrderInfo();

	updateNewsletterText(cartObj);

	updateFreePostageAttribute(cartObj);
	updateShippingTime(cartObj);

	updateProductSurprise(cartObj);

	updateWarrantySelector(cartObj);

	updateFreePptAccelerator(cartObj);

	updateKaskoSelector(cartObj);

	updateExtraCheckoutCross(cartObj);
}

function updateKaskoSelector(cartObj){
	var rebornProductIds = [];
	
	cartObj.products.forEach(function(product){
		if(product.productName && product.productName.toLowerCase().indexOf('reborn') !== -1 && product.productName.toLowerCase().indexOf('kasko') === -1) {
			rebornProductIds.push(product.productId);
		}
	});
	
	if(rebornProductIds.length != 1) {
		$('.additional-service.kasko-insurance').hide();
	} else {
		$('.additional-service.kasko-insurance').show();
	}
}

function updateExtraCheckoutCross(cartObj) {
	if(cartObj.extra_checkout_cross.data){
		var extraCheckoutCrossContainer = $('#outer-extra-offer-on-finish');
		if(extraCheckoutCrossContainer.length > 0){
			if(extraCheckoutCrossContainer.find('.extra-offer-on-finish').attr('data-level') != cartObj.extra_checkout_cross.data.levelId){
				if(cartObj.extra_checkout_cross.show){
					extraCheckoutCrossContainer.html(cartObj.extra_checkout_cross.render_html);
					initiateLightbox();
				}else{
					extraCheckoutCrossContainer.slideUp();
				}
			}
		}

		var firstProduct = $('#extra_cross_' + cartObj.extra_checkout_cross.data.product.first.pid);
		if(firstProduct.length > 0){
			if(!cartObj.extra_checkout_cross.data.product.first.inCart){
				firstProduct.removeClass('eg-product-active');
			}
			firstProduct.find('.product-details .cancel').attr('data-id', cartObj.extra_checkout_cross.data.product.first.cartProductId);
		}

		var secondProduct = $('#extra_cross_' + cartObj.extra_checkout_cross.data.product.second.pid);
		if(secondProduct.length > 0){
			if(!cartObj.extra_checkout_cross.data.product.second.inCart){
				secondProduct.removeClass('eg-product-active');
			}
			secondProduct.find('.product-details .cancel').attr('data-id', cartObj.extra_checkout_cross.data.product.second.cartProductId);
		}
	}
}

function updateFreePptAccelerator(cartObj) {
	if($("#freePptThreshold").length) {
		if(true === cartObj.isFreeppt) {
			$("#freePptThreshold").data("isFreePpt", "yes");
	
			$(".slim-notice.free-ppt-notice").hide();
		} else {
			$("#freePptThreshold").data("isFreePpt", "no");
	
			$("#freePptThreshold").html($("#freePptThreshold").data("text").replace("%value%", cartObj.diffToThreshold));
			$(".slim-notice.free-ppt-notice span").html($("#freePptThreshold").data("text").replace("%value%", cartObj.diffToThreshold));
			
			$(".slim-notice.free-ppt-notice").show();		
		}
	}
}

function updateWarrantySelector(cartObj){
	if($('.gift-packaging-body.warranty-selector').length > 0){
		cartObj.products.forEach(function(product){
			if(product.productType == 'product_warranty'){
				var existingElement = $('.warranty-selector .product-picker .product-wrapper .product[data-product-id=' + product.productId + '][data-parent-product-id=' + product.warrantyForProduct + ']');
				
				if(existingElement.length > 0){
					var markElement = existingElement.find('.mark');
					if(!markElement.hasClass('selected')){
						markElement.addClass('selected');
					}
					markElement.find('input[type="checkbox"]').attr('data-cart-id', product.id);
				}
			}
		});
	}
}

function updateProductSurprise(cartObj){
	$('.christmas_surprise_thankyou .remove-product').attr('data-id', '');
	var productSurprise = false;

	cartObj.products.forEach(function(product){
		if(product.productType == 'product_surprise'){
			productSurprise = true;
			$('.christmas_surprise_thankyou .remove-product').attr('data-id', product.id);
		}
	});

	if(productSurprise){
		$('.christmas_surprise_si').addClass('added');
		$('.mystery_box_product').addClass('added');
	}else{
		$('.christmas_surprise_si').removeClass('added');
		$('.mystery_box_product').removeClass('added');
	}
}

function updateShippingTime(cartObj) {
	if(typeof cartObj.shippingTime !== "undefined") {
		if($('#orderStatus .orderStatus__stockStatus .delivery').length) {
			var text = $('#orderStatus .orderStatus__stockStatus .delivery').data('text');
			text = text.replace('%from%', cartObj.shippingTime.from);
			text = text.replace('%to%', cartObj.shippingTime.to);

			$('#orderStatus .orderStatus__stockStatus .delivery').html(text);
		}
	}
}

function updateFreePostageAttribute(cartObj) {
	var attr = $('#thirdStepPostageChangedNotice').data('isFreeppt');
	if(typeof attr == "undefined") {
		$('#thirdStepPostageChangedNotice').data('isFreeppt', cartObj.isFreeppt);
	}
	if(attr == true && cartObj.isFreeppt == false && window.GIZZMO.__company_without_tax == true) {
		$('#thirdStepPostageChangedNotice').parent().slideDown();
		$('#thirdStepPostageChangedNotice').data('isFreeppt', cartObj.isFreeppt);
	}
	if(attr == false && cartObj.isFreeppt == true) {
		$('#thirdStepPostageChangedNotice').parent().slideUp();
		$('#thirdStepPostageChangedNotice').data('isFreeppt', cartObj.isFreeppt);
	}
}

function updateNewsletterText(cartObj) {
	if(cartObj.gdpr === true) {
		$('#newsletter').removeClass('new-customer').addClass('loyal-customer');
		$('#newsletter').find('input').prop('checked', true);
	} else {
		$('#newsletter').removeClass('loyal-customer').addClass('new-customer');
		$('#newsletter').find('input').prop('checked', false);
	}
}

function couponHandler(cartObj) {
	if(cartObj.couponCode !== null){
        couponCssAlreadyApplied(cartObj.couponCode);
    }
	else {
		removeCouponRow();
		couponCssRemove();
	}
}

function additionalServicesHandler(cartObj) {
	if(typeof cartObj.extras == "undefined") {
		window.location.reload();
		return false;
	}

	if(typeof cartObj.extras.warranty_product !== "undefined") {
		var $warrantyService = $('.additional-service.product-warranty');
		if(cartObj.extras.warranty_product.show === true) {
			$warrantyService.css('display', 'block');
		} else {
			$warrantyService.removeClass('selected')
			$warrantyService.find('input').prop('checked',false);
			$warrantyService.hide();
		}

		if(cartObj.addedExtras.includes(cartObj.extras.warranty_product.id)){
			$warrantyService.addClass('selected')
			$warrantyService.find('input').prop('checked',true);
		}else{
			$warrantyService.removeClass('selected')
			$warrantyService.find('input').prop('checked',false);
		}
	}

	if(typeof cartObj.extras.fast_shipping_product !== "undefined") {
		var $fast_shipping_product = $('.additional-service.first-row-priroity');
		var fastShippingDaysLimit = 2;
		if(window.jstransobj.locale == "cz") {
			fastShippingDaysLimit = 3;
		}
		if(cartObj.extras.fast_shipping_product.show === true && cartObj.shippingTime.to <= fastShippingDaysLimit) {
			$fast_shipping_product.css('display', 'block');
		} else {
			$fast_shipping_product.removeClass('selected')
			$fast_shipping_product.find('input').prop('checked',false);
			$fast_shipping_product.hide();
		}
	}

	if(typeof cartObj.extras.premium_insurance_product !== "undefined") {
		var $premium_insurance = $('.additional-service.premium-insurance');
		if(cartObj.extras.premium_insurance_product.show === true) {
			$premium_insurance.css('display', 'block');
		} else {
			$premium_insurance.removeClass('selected')
			$premium_insurance.find('input').prop('checked',false);
			$premium_insurance.hide();
		}
	}

	if(typeof cartObj.extras.gift_packaging !== "undefined") {
		var $gift_packaging = $('.additional-service.gift-packaging');
		if(cartObj.extras.gift_packaging.show === true) {
			if(cartObj.extras.gift_packaging.selected === true){
				$gift_packaging.find('input').prop('checked',true);
				$gift_packaging.addClass('selected');
			}else{
				$gift_packaging.find('input').prop('checked',false);
				$gift_packaging.removeClass('selected');
			}
			$gift_packaging.css('display', 'block');
		} else {
			$gift_packaging.removeClass('selected')
			$gift_packaging.find('input').prop('checked',false);
			$gift_packaging.hide();
		}
	}
}

function updateQuantity(obj, caller) {
    if(!window.jstransobj) {
        window.jstransobj = { linkPrefix : "" };
    }
    var cartId = getCookie('cart');
    $.ajax ({
        url: jstransobj.linkPrefix + '/cart/update/qty',
        data: obj,
        method: 'POST',
        cache: false,
        success: function (data) {

        	if(typeof data.status !== 'undefined' && data.status === false){
        		alert(data.message);
			}

			if($('#orderStatus__couponStatus__input').data('reapply') == true) {
				// $('#orderStatus__couponStatus__input').val($('#orderStatus__couponStatus__input').data('coupon'));
				revalidateCoupon();
			} else {
				refreshCart();
			}
            sibPush(cartId);
        },
        error: function(data) {
            if(typeof _errs == 'object') {
                _errs.push(new Error(data.responseText + "~~~~~~~~~~~" + getCookie("cart")));
            }
        },
        complete: function() {
        }
    });
}

function updatePostage(obj) {

    if(GIZZMO.__updatePostageAjax != null) {
        GIZZMO.__updatePostageAjax.abort();
        GIZZMO.__updatePostageAjax = null;
    }

    toggleLoadingAnimation("tables_wrapper", []);
    toggleLoadingAnimation("giftWrapper");

    if(!window.jstransobj) {
        window.jstransobj = { linkPrefix : "" };
    }

    GIZZMO.__updatePostageAjax = $.ajax ({
        url: jstransobj.linkPrefix + '/cart/update/shipping',
        data: obj,
        method: 'POST',
        cache: false,
        success: function (data) {
            refreshCart();
        },
        error: function(data) {
            if(data.statusText =! "abort") {
                if(typeof _errs == 'object') {
                    _errs.push(new Error(data.responseText + "~~~~~" + getCookie("cart")));
                }
            }
        },
        complete: function() {
            toggleLoadingAnimation("tables_wrapper", []);
        }
    });
}

function resetPostage() {
    changePaymentMethod();

    if(!window.jstransobj) {
        window.jstransobj = { linkPrefix : "" };
    }
    $.ajax ({
        url: jstransobj.linkPrefix + '/cart/update/resetpostage',
        method: 'POST',
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        cache: false,
        success: function (data) {
            refreshCart();
        },
        error: function(data) {
            if(typeof _errs == 'object') {
                _errs.push(new Error(data.responseText + "~~~~~~~~" + getCookie("cart")));
            }
        },
        complete: function() {
        }
    });
}

function getShippingCosts(shippingCountryId) {

    if ( typeof shippingCountryId == "undefined" ) {
        shippingCountryId = {'shipping_country': 'null'};
    }

    if(!window.jstransobj) {
        window.jstransobj = { linkPrefix : "" };
    }

    $.ajax ({
        url: jstransobj.linkPrefix + '/cart/postages/list',
        data: shippingCountryId,
        method: 'POST',
        cache: false,
        success: function (data) {
            window.GIZZMO.__globalPostage.costs = data;
            setPaymentMethods();
            updateModulePostages(window.GIZZMO.__globalPostage.shipping);
        },
        error: function(data) {
            if(typeof _errs == 'object') {
                _errs.push(new Error(data.responseText + "~~~~~" + getCookie("cart")));
            }
        }
    });
}

function setPaymentMethods() {
    window.GIZZMO.__globalPostage.costs.forEach(function(element) {

    });
}

function updateMoneySavingNotice() {
    return;
    var value = 0;
    var currency = "";
    var methods = window.GIZZMO.__globalPostage.costs.filter(function(method) { return method.billing == "cod" || method.billing == "credit_card" });
    if(methods.length > 1) {
        value = Math.abs(parseInt(methods[0].value) - parseInt(methods[1].value));
        currency = methods[0].value.split(" ");
        currency = currency[1];
        $( "#save-money" ).html( $( "#save-money" ).html().replace('%value%', value + " " + currency) );

        if(value == 0) {
            $( "#save-money" ).attr('dont-show',false);
        }
        else {
            $( "#save-money" ).attr('dont-show',true);
        }
    }
}

function showMoneySavingNotice() {
    return;
    if( $( "#save-money" ).attr('dont-show') == "true" ) {
        $( "#save-money" ).slideDown();
    }
}

function hideMoneySavingNotice() {
    return;
    if( $( "#save-money" ).attr('dont-show') == "true" ) {
        $( "#save-money" ).slideUp();
    }
}

function updateModulePostages(shipping) {
    $('.cart__pMethods__wrapper div.select').hide();

    updateMoneySavingNotice();
    $('#pMethodsModuleWrapper').children().each(function() {
       var billing = $(this).find('input').attr('billing');
       window.GIZZMO.__globalPostage.costs.forEach(function(currentValue) {
           if(currentValue.billing == billing && currentValue.shipping == shipping) {
               $('['+billing+']').html(currentValue.value);
               $('['+billing+']').parents('.select').show();
           }
       });
    });

    $('.cart__pMethods__wrapper div.select:visible').each(function(index) {
        $(this).attr('multiplier', index);
    });
}

function creditCardPlaceholderAnimationShow(elementId) {
    var span = $('#'+elementId).parent().children('span');
    var input = $('#'+elementId).parent().children('div');

    span.css('display','inline-block');

    input.stop().delay(80).animate(
        {
            'padding-top': '20px'
        }, 280
    );
    span.stop().delay(80).animate(
        {
            'opacity': '1'
        }, 280
    );
}

function creditCardPlaceholderAnimationHide(elementId) {
    var span = $('#'+elementId).parent().children('span');
    var input = $('#'+elementId).parent().children('div');

    span.css('display','inline-block');

    span.stop().animate(
            {
                'opacity': '0'
            }, 1, function () {
        input.stop().animate(
                {
                    'padding-top': '0px' //hack 1px
                }
            );
        }
    );
}

function updateStoredCartArticleNames(_article,span) {
    $.data(_article, "percentage", {name: span});
}

function productStockStatusHandler(cartObj) {
    adaptTableRowHeight();
    highlightStockIssues();
    if(cartObj.productStockStatus === false) {
        GIZZMO.__isStockFalse = true;
        deactivateButton.call($('.secondStep__continue')[0]);
        $('#orderStatus [stock_status_true]').hide();
        $('#orderStatus [stock_status_false]').show();
    }
    else {
        GIZZMO.__isStockFalse = false;
        if(isPaymentMethodSelected()) {
            activateButton.call($('.secondStep__continue')[0]);
        }
        $('#orderStatus [stock_status_false]').hide();
        $('#orderStatus [stock_status_true]').show();
    }
    var $products = $('[data-filter="productrow"]');
    $(cartObj.products).each(function(index) {
        var $stockParagraph = $($products[index]).find('.table__cell__articleStock');
        if(this.stock.message != null) {
            $stockParagraph.html(this.stock.message);
            // $stockParagraph.show();
        }
        else {
            $stockParagraph.html(this.stock.message);
            // $stockParagraph.hide();
        }
    });

	sendOutOfStockPushNotifications(cartObj);
}

function sendOutOfStockPushNotifications(cartObj) {
	var queryString = {};
	if(cartObj.products.length > 0) {
		$(cartObj.products).each(function(key, product) {
			if(["coupon_gift"].indexOf(product.productType) !== -1) {
				if(product.stock.onStock == false && GIZZMO.__pushedOutOfStockProductIds.indexOf(product.productId) === -1) {
					queryString = {};
					queryString = {
						coupon: $('#orderStatus__couponStatus__input').val(),
						productname: product.productName,
						productid: product.productId,
						siteuri: window.location.href
					};
					GIZZMO.__pushedOutOfStockProductIds.push(product.productId);

					$.ajax({
						url: "https://hook.integromat.com/fchb3dyafqxe9rx3zpk41mzpem7en8q2",
						method: "POST",
						data: queryString
					});
				}
			}
		});
	}
}

function refreshCart() {
	if(!window.jstransobj) {
        window.jstransobj = { linkPrefix : "" };
    }

    $.ajax({
        url: jstransobj.linkPrefix + '/cart/get',
        method: 'POST',
		data: {'get_full_array' : true},
        cache: false,
        success : function (cartObj) {
            updateCartFields(cartObj);
        },
        error: function(data) {
            asyncalert(jstransobj.error);
            if(typeof _errs == 'object') {
                _errs.push(new Error(data.responseText));
            }
        },
        complete: function() {
			GIZZMO.__ajax_active = null;
			getShippingCosts({'shipping_country': window.GIZZMO.__isInternational != -1? window.GIZZMO.__isInternational : 'null'});
        }
    });
}


function rebuildGifts() {
	var giftsCookie = getCookie("gifts");
	if( typeof giftsCookie != "undefined" && giftsCookie != "" ) {
        GIZZMO.giftArray = JSON.parse( getCookie("gifts") );

        $('.giftContainer__gift').each(function() {
            $(this).removeClass('giftContainer__gift--active').addClass('giftContainer__gift--passive');
            $(this).find('input').prop('checked', false);
        });

        var count = [];
        $('.giftContainer').each(function() {
            count.push( $(this).data('count') );
        });

        GIZZMO.giftArray.forEach(function(giftGroup, groupIndex) {
            giftGroup.forEach(function(id, giftIndex) {
                if( $('#g'+id).length > 0 ) {
                    if(count[groupIndex] > giftIndex) {
                        $('#g'+id).removeClass('giftContainer__gift--passive').addClass('giftContainer__gift--active').find('input').prop('checked', true);
                    }
                }
            });
        });
    }

    GIZZMO.giftArray = [];

    $('.giftContainer').each(function(index) {
        if( typeof GIZZMO.giftArray[index] == "undefined" ) {
            GIZZMO.giftArray[index] = [];
        }
        $(this).children('.giftContainer__gift').each(function() {
            if( $(this).find('input').prop('checked') == true ) {
                GIZZMO.giftArray[index].push( $(this).data('id') );
            }
        });
    });
	if(GIZZMO.giftArray.length) {
		setWaveCookie("gifts", JSON.stringify( GIZZMO.giftArray ), 1);
	}
	updateSelectedGiftsCounter();
}

function updateGifts(cartObj) {
	if(cartObj.siteHasGifts !== true) {
        return false;
    }

    if(!window.jstransobj) {
        window.jstransobj = { linkPrefix : "" };
    }

    $.ajax({
        url: jstransobj.linkPrefix + '/cart/render/gifts',
        method: 'GET',
        cache: false,
        success: function (data) {
            if (data['json'].teaser == "/") {
                $('#topGiftNotice').parent().hide();

                recalculateOrderStatusPosition();
            } else {
                $('#topGiftNotice').parent().show();
                $('#topGiftNotice').html(data['json'].teaser);

                recalculateOrderStatusPosition();
            }

            $('#giftWrapper').replaceWith(data['html']);
            rebuildGifts();
        },
        error: function(data) {
            if(typeof _errs == 'object') {
                _errs.push(new Error(data.responseText + "~~Error updating gifts~~" + getCookie("cart")));
            }
        },
        complete: function() {
        }
    });

}

function onKeyUpInputCall() {
    var parent = $(this).parent('div');

    var input = parent.children('input');

    var placeholder = parent.children('span');
    if (input.attr('placeholder') == '' || input[0].value == '') {// tu preprečimo animacijo, dokler ni vsebine
        return;
    }
    input.attr('placeholder', '');
    placeholder.css('display', 'inline-block');
    placeholder.stop().delay(80).animate(
        {
            'opacity': '1'
        }, 280
    );
    input.stop().delay(80).animate(
        {
            'padding-top': '20px'
        }, 280
    );
}



function trimArticleName() {
    var _articles = $('.table__cell__articleName');
    var _length = $(_articles).length;

    if (window.innerWidth <= 420) {
        for (var i = 0; i < _length; i++) {
            _string = $(_articles[i]).html();
            if ($.data(_articles[i], "content").name.length > 50) {
                typeof $.data(_articles[i], "percentage") != 'undefined' ? $(_articles[i]).html($.data(_articles[i], "percentage").name + $.data(_articles[i], "content").name.substring(0, 50) + "...") : $(_articles[i]).html($.data(_articles[i], "content").name.substring(0, 50) + "...");
            } else {
                typeof $.data(_articles[i], "percentage") != 'undefined' ? $(_articles[i]).html($.data(_articles[i], "percentage").name + $.data(_articles[i], "content").name) : $(_articles[i]).html($.data(_articles[i], "content").name);
            }
        }
    } else {
        for (var i = 0; i < _length; i++) {
            _string = $(_articles[i]).html();
            if ($.data(_articles[i], "content").name.length > 100) {
                typeof $.data(_articles[i], "percentage") != 'undefined' ? $(_articles[i]).html($.data(_articles[i], "percentage").name + $.data(_articles[i], "content").name.substring(0, 100) + "...") : $(_articles[i]).html($.data(_articles[i], "content").name.substring(0, 100) + "...");
            } else {
                typeof $.data(_articles[i], "percentage") != 'undefined' ? $(_articles[i]).html($.data(_articles[i], "percentage").name + $.data(_articles[i], "content").name) : $(_articles[i]).html($.data(_articles[i], "content").name);
            }
        }
    }
}

function recalculateOrderStatusPosition() {
	var multiplier = 0;

	if($('#__discountvalue').length) {
		multiplier++;
	}

	if($('#__vatvalue').length) {
		multiplier++;
	}

	var initialMargin = -204;

	$('.orderStatus').css('margin-top', initialMargin + (-64 * multiplier));
}

function moveQuantitySelector() {
    if(window.innerWidth <= 926) {
        $( '.quantity__wrapper' ).each(function() {
			$(this).show();
            $(this).parents('.table__row').find('[secondcell]').append($(this));
        });
    }
    else {
        $( '.quantity__wrapper' ).each(function() {
			$(this).show();
            $(this).parents('.table__row').find('[thirdcell]').append($(this));
        });
    }
}

function adaptTableRowHeight() {
    $('.table.first .table__row').each(function() {
        var properties_h = 0;
        var out_of_stock_h = 0;
        var quantity_discount_h = 0;
		var article_Icon = 0;
        var name_h = $(this).find('.table__cell__articleName').outerHeight(true);
        var quantity_h = $(this).find('.quantity__wrapper').outerHeight(true);
        if($(this).find('.table__cell__articleProperties').length > 0) {
            properties_h = $(this).find('.table__cell__articleProperties').outerHeight(true);
        }
        if($(this).find('.table__cell__articleStock').length > 0 ) {
            out_of_stock_h = $(this).find('.table__cell__articleStock').outerHeight(true) + 10;
        }
		if($(this).find('.table__cell__articleQuantityDiscount').length > 0 && $(this).find('.table__cell__articleQuantityDiscount').css('display') != 'none') {
			quantity_discount_h = $(this).find('.table__cell__articleQuantityDiscount').outerHeight(true);
		}
		if($(this).find('.table__cell__articleIcon').length > 0) {
			article_Icon = $(this).find('.table__cell__articleIcon').outerHeight(true) * $(this).find('.table__cell__articleIcon').length;
		}

		if(window.innerWidth > 926) {
			quantity_h = 0;
		}

        var height = properties_h + out_of_stock_h + name_h + quantity_h + quantity_discount_h + article_Icon;

        if(height <= 125) {
            height = 125;
        }
        $(this).height(height);
    });
}

function moveCouponFrontRender() {
    if(window.innerWidth <= 926) {
        $('[coupon-wrapper-mobile]').append($('[coupon-wrapper-desktop]').children());
    }
    else {
        $('[coupon-wrapper-desktop]').append($('[coupon-wrapper-mobile]').children());
    }
}

function moveAdditionalService() {
	if(window.innerWidth <= 926) {
		$('[additional-service-wrapper-mobile]').append($('[additional-service-wrapper-desktop]').children());
	}
	else {
		$('[additional-service-wrapper-desktop]').append($('[additional-service-wrapper-mobile]').children());
	}
}

function enableVatRegistered() {
	$('.thirdStep__vat_check_container').removeClass('disabled');

	$('#countryCombobox').attr('disabled', false);
	$('.input__vat').removeClass('not-registered');
	if($('#vat_country').val().toString().toUpperCase() == "HU"){
		$('#idddv').attr('maxlength',8);
	}

	if( $('#vat_country').val().toString().toUpperCase() != "DE" &&
		$('#vat_country').val().toString().toUpperCase() != "SI") {
		$('#companyUserAddress').attr('disabled', true);
	}
	$('#companyUserAddress').removeClass('input__valid input__invalid');
	$('#companyUserAddress').trigger('focusout');

	if( $('#vat_country').val().toString().toUpperCase() != "DE" &&
		$('#vat_country').val().toString().toUpperCase() != "SI") {
		$('#companyName').attr('disabled', true);
		$('#companyName').val("");
		$('#companyUserAddress').val("");
	}
	$('#companyName').removeClass('input__valid input__invalid');
	$('#companyName').trigger('focusout');

	$('#vat-error-notice').hide();

	if( $('#vat_country').val().toString().toUpperCase() == "SI" ) {
		window.GIZZMO.__company_vies_status = true;
		window.GIZZMO.__company_without_tax = false;
	}

	if($("#reborn-marginal-vat-notice").length) {
		$("#reborn-marginal-vat-notice").show();
	}
}

function disableVatRegistered() {
	$('.thirdStep__vat_check_container').addClass('disabled');

	$('#countryCombobox').attr('disabled', true);

	$('.input__vat').addClass('not-registered');
	$('#idddv').val("");
	$('#idddv').removeClass('input__valid input__invalid');

	if($('#vat_country').val().toString().toUpperCase() == "HU"){
		$('#idddv').attr('maxlength',false);
	}

	$('#companyUserAddress').attr('disabled', false);
	$('#companyUserAddress').val("");
	$('#companyUserAddress').removeClass('input__valid input__invalid');
	$('#companyUserAddress').trigger('focusout');

	$('#companyName').attr('disabled', false);
	$('#companyName').val("");
	$('#companyName').removeClass('input__valid input__invalid');
	$('#companyName').trigger('focusout');

	$('#vat-error-notice').hide();

	resetVatInputStyles();


	if($("#reborn-marginal-vat-notice").length) {
		$("#reborn-marginal-vat-notice").hide();
	}
}

function resetVatInputStyles() {
	$('.thirdStep__vat_check_container').removeClass('fail success');
	$('.thirdStep__vat_response').removeClass('fail success');

	$('.thirdStep__vat_response').hide();
}

function checkVAT() {

	$('#confirm-vat').addClass('checking');
	toggleLoadingAnimation("confirm-vat", []);

	var clean_these_strings = [
		"Slovensko"
	];

	resetVatInputStyles();

	var data = {
		countryCode: $('#vat_country').val(),
		vatId: $('#idddv').val()
	};

	var $p = $('.thirdStep__vat_response p');

	$.ajax({
        cache: false,
        url: jstransobj.linkPrefix + '/vies/check',
        method: 'POST',
        data: data,
		timeout: 10000,
        success: function (data) {
			if(data.valid === true) {
				window.GIZZMO.__company_vies_status = data.valid;
				window.GIZZMO.__company_without_tax = data.withoutTax;

				var companyName = data.companyName;
				var companyAddress = data.companyAddress;

				for (var i=0; i < clean_these_strings.length; i++) {
					var regExp = new RegExp(clean_these_strings[i], 'gi');
					companyAddress = companyAddress.replace(regExp,'');
				}

				$('#returned-company-address').html(companyAddress.replace(/\n/g, "<br />"));

				companyAddress = companyAddress.replace(/\n/g, " ");

				$p.html( $p.data('validText') );
				$('.thirdStep__vat_check_container').addClass('success');
				$('.thirdStep__vat_response').addClass('success');

				if( $('#vat_country').val().toString().toUpperCase() != "DE" ) {
					$('#companyName').val(companyName);
					onKeyUpInputCall.call($('#companyName'));
					$('#companyName').addClass('input__valid');

					$('#companyUserAddress').val(companyAddress);
					onKeyUpInputCall.call($('#companyUserAddress'));
					$('#companyUserAddress').addClass('input__valid');
				}
			}
			else if(data.valid === false) {
				$p.html( $p.data('invalidText') );
				$('.thirdStep__vat_response').addClass('fail');
				$('.thirdStep__vat_check_container').addClass('fail');
			}
			else if(data.valid === null) {
				$p.html( data.message );
				$('.thirdStep__vat_response').addClass('fail');
				$('.thirdStep__vat_check_container').addClass('fail');
			}
        },
		error: function (xmlhttprequest, textstatus, message) {
            if (typeof _errs == 'object') {
                _errs.push(new Error("VIES TIMEOUT: " + message));
            }

			$p.html( window.jstransobj.error );
			$('.thirdStep__vat_response').addClass('fail');
			$('.thirdStep__vat_check_container').addClass('fail');
        },
		complete: function() {
			$('.thirdStep__vat_response').slideDown();

			toggleLoadingAnimation("confirm-vat", []);
			$('#confirm-vat').removeClass('checking');

			refreshCart();
		}
    });
}

function checkAndNotifyPostagesChanges() {
	$('#thirdStepPostageChangedNotice').show();
}

function resetVAT() {
	$.ajax({
        cache: false,
        url: jstransobj.linkPrefix + '/vies/reset',
        method: 'POST',
        success: function (data) {
			//console.log(data);
        },
        error: function (data) {
            if (typeof _errs == 'object') {
                _errs.push(new Error(data.responseText));
            }
        },
		complete: function() {
			refreshCart();
			updateBottomOrderInfo();
			window.GIZZMO.__company_vies_status = null;
			window.GIZZMO.__company_without_tax = null;
		}
    });
}

function similarity(s1, s2) {
    var longer = s1;
    var shorter = s2;
    if (s1.length < s2.length) {
        longer = s2;
        shorter = s1;
    }
    var longerLength = longer.length;
    if (longerLength === 0) {
        return 1.0;
    }
    return ((longerLength - editDistance(longer, shorter)) / parseFloat(longerLength))*100;
}

function editDistance(s1, s2) {
    s1 = s1.toLowerCase();
    s2 = s2.toLowerCase();

    var costs = new Array();
    for (var i = 0; i <= s1.length; i++) {
        var lastValue = i;
        for (var j = 0; j <= s2.length; j++) {
            if (i == 0)
                costs[j] = j;
            else {
                if (j > 0) {
                    var newValue = costs[j - 1];
                    if (s1.charAt(i - 1) != s2.charAt(j - 1))
                        newValue = Math.min(Math.min(newValue, lastValue),
                            costs[j]) + 1;
                    costs[j - 1] = lastValue;
                    lastValue = newValue;
                }
            }
        }
        if (i > 0)
            costs[s2.length] = lastValue;
    }
    return costs[s2.length];
}

function isShippingSameAsBilling() {

	var str1 = $('#companyUserAddress').val();
	var str2 = [];
	str2.push($('#userAddress').val());
	str2.push($('#userPostalcode').val());
	str2.push($('#userCityhall').val());
	str2 = str2.join(" ");

	if(similarity(str1, str2) > 30) {
		return true;
	}

	return false;
}

function goToFinishButton() {
	$('html, body').animate({
		'scrollTop' : $('#continue3').offset().top - 24
	});

	$('#continue3').addClass('glow');
    setTimeout(function() {
        $('#continue3').removeClass('glow');
    }, 5000);
}

function vatRegisteredShippingAddress_matchFailed() {
	$('#userAddress').removeClass('input__valid').addClass('input__invalid');
	$('#userPostalcode').removeClass('input__valid').addClass('input__invalid');
	$('#userCityhall').removeClass('input__valid').addClass('input__invalid');
}

function vatRegisteredShippingAddress_matchSuccess() {
	$('#userAddress').removeClass('input__invalid').addClass('input__valid');
	$('#userPostalcode').removeClass('input__invalid').addClass('input__valid');
	$('#userCityhall').removeClass('input__invalid').addClass('input__valid');
}

function showVatRegistered() {
	$('.thirdStep__vat_registered').show();
}

function hideVatRegistered() {
	$('.thirdStep__vat_registered').hide();
	disableVatRegistered();
	$('#vat_registered_checkbox').prop('checked', false);
}

function clearCompanyAddress() {
	$('#companyUserAddress').val("").removeClass('input__valid input__invalid');
	$('#companyUserAddress').trigger('focusout');

	$('#companyName').val("").removeClass('input__valid input__invalid');
	$('#companyName').trigger('focusout');

}

function sendinblueIdentifyPush(email) {
	if(typeof sendinblue === 'object') {
		sendinblue.identify(email, {});
	}
}

function klaviyoIdentifyPush(email) {
	if (typeof klaviyoIdentify === "function") { 
		klaviyoIdentify(email, function(){
			setTimeout(function(){klaviyoStartedCheckout();}, 1000);
		});
	}
}

function revalidateCoupon() {
	if($.trim($('#orderStatus__couponStatus__input').val()) != "") {
		applyCouponAjax();
	}
}

function handleSecondStepCouponNotice(messages) {
	$('#secondStepCouponNotice').parent().hide();
	if(typeof messages !== "undefined" && messages !== null) {
		if(messages.length > 0) {
			/* clear duplicated messages */
			messages = Array.prototype.filter.call(messages, function(element, index, array) {
				return array.indexOf(element) === index;
			});

			var text = "";
			messages.forEach(function(message) {
				text += message + "<br>";
			});
			$('#secondStepCouponNotice').html(text);
			$('#secondStepCouponNotice').parent().show();

			$('#secondStepCouponNotice').parent().addClass('glow');
			setTimeout(function() {
				$('#secondStepCouponNotice').parent().removeClass('glow');
			}, 4000);

			$('body, html').animate({
				scrollTop: $('#secondStepCouponNotice').offset().top - 20
			});
		}
	}
}

function applyCouponAjax() {
	$.ajax({
		url: jstransobj.linkPrefix + '/coupon/add',
		method: 'POST',
		cache: false,
		data: { 'code' : $('#orderStatus__couponStatus__input').val().split(" ").join("") },
		success: function (data) {
			if(data.status === true) {
				couponCssSuccess();
				handleSecondStepCouponNotice(data.message);
				$('#orderStatus__couponStatus__input').data('coupon', $('#orderStatus__couponStatus__input').val());
				$('#orderStatus__couponStatus__input').data('reapply', data.reapply);
			}
			else {
				// asyncalert(data.message);
				handleSecondStepCouponNotice(data.message);
				couponCssFailed();
				$('#orderStatus__couponStatus__input').data('coupon', "");
				$('#orderStatus__couponStatus__input').data('reapply', data.reapply);
			}
		},
		error: function(data) {
			asyncalert(jstransobj.error);
			couponCssFailed();
			if(typeof _errs == 'object') {
				_errs.push(new Error(data.responseText));
			}
		},
		complete: function(data) {
			refreshCart();
		}
	});
}

function disableAllPickupBoxLocations() {
	$('[shipping*="pickupbox"]').each(function(index, el) {
		$(el).parents('.cart__store').addClass('cart__store--disabled');
	});
}

function checkPickupboxAvailability() {

	if(GIZZMO.__pickupBoxAvailabilityAjax !== null) {
		GIZZMO.__pickupBoxAvailabilityAjax.abort();
	}

	GIZZMO.__pickupBoxAvailabilityAjax = $.ajax({
		url: jstransobj.linkPrefix + '/cart/pickupbox/check-availability',
		method: 'POST',
		cache: false,
		timeout: 8000,
		success: function(response) {
			if(response.status === true) {
				for(var key in response.data) {
					var $input = $('[shipping="'+key+'"]');
					if($input.length) {
						if(response.data[key].availability === true) {
							$input.parents('.cart__store').removeClass('cart__store--disabled');
						} else {
							$input.parents('.cart__store').addClass('cart__store--disabled');
						}
					}
				}
			} else {
				disableAllPickupBoxLocations();
			}
		},
		error: function(response) {
			disableAllPickupBoxLocations();
		},
		complete: function(response) {
			GIZZMO.__pickupBoxAvailabilityAjax = null;
		}
	});
}

function updateSelectedGiftsCounter() {
	var length = $('.giftContainer input:checked').length;
	if(length == 0) {
		$('#selectedGiftsCounter .text').html($('#selectedGiftsCounter').data('noThanksText'));
	} else {
		$('#selectedGiftsCounter .text').html(
			$('#selectedGiftsCounter').data('selectedGifts').replace("%selected_count%", length).replace("%maximum_count%", $('#selectedGiftsCounter').data('maxGiftsCount'))
		);
	}
}

function addCrossSellFromQuickview(data, callback) {        
	$('.iframe-lightbox .backdrop').trigger('click');

	var quantity = data.quantity;
	var productId = data.productId;

	$('#cs'+productId).find('.atc-button').data('quantity', quantity);
	$('#cs'+productId).find('.atc-button').each(function (index, element) {
		if($(element).css('display') != "none") {
			$(element).trigger('click');
		}		
	});
}

//FUNCTIONS

window.GIZZMO = {};
GIZZMO.__showFormError = true;
GIZZMO.__showCreditCardError = true;
GIZZMO.__creditCardTrials = 0;
GIZZMO.__checkout = null;
GIZZMO.__nonce = null;
GIZZMO.__paymentMethodWrapperHeight = null; // potrebujemo globalno spremenljivko, da lahko kasneje vrnemo na višino
GIZZMO.__storeWrapperHeight = null; // potrebujemo globalno spremenljivko, da lahko kasneje vrnemo na višino
GIZZMO.__turboNoticeHeight = 0; // potrebujemo globalno spremenljivko, da lahko kasneje vrnemo na višino
GIZZMO.__globalPostage = {
    billing: "",
    shipping: "delivery",
    costs: {}
};
GIZZMO.__isInternational = -1; // se nastavi v element triggers, kadar uporabnik izbere državo
GIZZMO.__waitinitialization = 0;
GIZZMO.__blockimpatience = 0;
GIZZMO.__isStockFalse = 0;
GIZZMO.__preventDuplicateEvents = {
    'step1' : 1,
    'step2' : 1
};

GIZZMO.__creditCardAjax = null;
GIZZMO.__payPalAjax = null;
GIZZMO.__updatePostageAjax = null;
GIZZMO.__resetPostageAjax = null;
GIZZMO.__company_without_tax = null;
GIZZMO.__pickupBoxAvailabilityAjax = null;
GIZZMO.__company_vies_status = null;
GIZZMO.__ajax_active = null;
GIZZMO.__phoneNumberValidationAjax = null;
GIZZMO.__pushedOutOfStockProductIds = [];

GIZZMO.__buttonActivationColor = "#00adf2";

GIZZMO.giftPackagingElement = null;
GIZZMO.selectorElement = null;
GIZZMO.secretBoxElement = null;
GIZZMO.__lottie = null;

(function() {
    if(window.jstransobj.sitebrand == "nitro") {
        var arr = $('#trimHost').text().split('.');
        arr.shift();
        $('#trimHost').text( arr.join('.') );
    }
})();

window.asyncalert = function (delayedMessage) {
    setTimeout(function() {
        alert(delayedMessage);
    },400);
};

// To change labels on 'Kasko insurance' block
function kaskoInsuranceLabelsChange() {
	// Select the two label elements
	var $label24 = $('.kasko-label-24');
	var $labelPopular = $('.kasko-label-popular');

	if ($label24.length && $labelPopular.length) {
    $label24.show();
    $labelPopular.hide();

    // Set up an interval to toggle visibility every 5 seconds
    setInterval(function() {
      if ($label24.is(':visible')) {
        $label24.fadeOut(500, function() { 
          $labelPopular.fadeIn(500);
        });
      } else {
        $labelPopular.fadeOut(500, function() {
          $label24.fadeIn(500);
        });
      }
    }, 5000);
  }
}

function openModalKaskoInsurance() {
	document.querySelector('.kasko-insurance-modal').style.display = 'block';
	setTimeout(function() {
	  document.querySelector('.kasko-insurance-modal .modal-content').classList.add('open');
	}, 10); // Add a small delay to ensure the display property is set
}

function closeModalKaskoInsurance() {
	document.querySelector('.kasko-insurance-modal .modal-content').classList.remove('open');
	setTimeout(function() {
	  document.querySelector('.kasko-insurance-modal').style.display = 'none';
	}, 500); // Match this duration with the CSS transition duration
}

if(document.querySelector('#kasko-insurance-more')){
	document.querySelector('#kasko-insurance-more').onclick = function(event) {
		event.preventDefault(); // Prevent the default anchor behavior
		openModalKaskoInsurance();
	};
}

var $closeButtons = $('.kasko-insurance-modal .close, .kasko-insurance-modal .close-square');
if ($closeButtons.length > 0) {
	$closeButtons.on('click', function() {
		closeModalKaskoInsurance();
	});
}

window.addEventListener('click', function(event) {
  if (event.target.classList.contains('kasko-insurance-modal')) {
    closeModalKaskoInsurance();
  }
});

// Accordion on Kasko Sidepanel
function setAccordions() {
	var accordionSections = $('.kasko-modal-faq');

	if (accordionSections.length > 0) {
		accordionSections.each(function() {
			var accordionSection = $(this);
			var accordionItems = accordionSection.find('.faq-item');
			
			accordionItems.each(function() {
				var item = $(this);
				var header = item.find('.faq-header');
				var body = item.find('.faq-body');
	
				header.on('click', function() {
					header.toggleClass('collapse');
					body.toggleClass('collapsed');
		
					if (body.hasClass('collapsed')) {
						body.css('height', '0');
					} else {
						body.css('height', body[0].scrollHeight + 'px');
					}
				});
			});
		});
	}
}

setAccordions();

// on SCRIPT LOAD
$(function () {
    //$('#firstStep__email').find('input').val("miha.kocevar@wave.si");
    //------------------------------------------------------------------------------------------
    if (window.innerWidth <= 874) {
        window._globalStepPadding = "36px";
    } else {
        window._globalStepPadding = "44px";
    }
	//------------------------------------------------------------------------------------------
	if (window.innerWidth <= 767) {
		if($('.qd-text span.qd-teaser').length > 0){
			$('.qd-text span.qd-teaser').html(window.jstransobj.quantityDiscountMobileText);
		}
	}
    //------------------------------------------------------------------------------------------
    if (window.innerWidth <= 620) {
        $('#firstStep__email').children('input').attr('placeholder', jstransobj.emailText);
    }
    //------------------------------------------------------------------------------------------
    if (window.innerWidth <= 357) {
        $('.paypalPick__right').html(window.jstransobj.paypalConnectText1);
    }
    //------------------------------------------------------------------------------------------
    if (window.innerWidth <= 366) {
        $('#continue1 span').html(window.jstransobj.continueButtonText2);
    }
    //------------------------------------------------------------------------------------------
    //trimArticleName();
    moveQuantitySelector();
    adaptTableRowHeight();
    moveCouponFrontRender();
	moveAdditionalService();
    //-------------------------------------------------------------------------------------------
    $(".meter > span").width('18%');
    //-------------------------------------------------------------------------------------------
    $("#progressBar").sticky({topSpacing: 0, zIndex: 1});
    //-------------------------------------------------------------------------------------------

    // on RESIZE
    window.onresize = function (event) {
        moveQuantitySelector();
        adaptTableRowHeight();
        moveCouponFrontRender();
		moveAdditionalService();
        //------------------------------------------------------------------------------------------
        if (window.innerWidth <= 874) {
            window._globalStepPadding = "36px";
        } else {
            window._globalStepPadding = "44px";

            recalculateOrderStatusPosition();
        }
        //------------------------------------------------------------------------------------------
        if (window.innerWidth <= 620) {
            $('#firstStep__email').children('input').attr('placeholder', jstransobj.emailText);
        } else {
            $('#firstStep__email').children('input').attr('placeholder', jstransobj.firstStepEmailPlaceholder);
        }
        //------------------------------------------------------------------------------------------
        if (window.innerWidth <= 767) {
            $('.paypalPick__right').html(jstransobj.paypalConnectText1);
			if($('.qd-text span.qd-teaser').length > 0){
				$('.qd-text span.qd-teaser').html(window.jstransobj.quantityDiscountMobileText);
			}
        } else {
            $('.paypalPick__right').html(jstransobj.paypalConnectText2);
			if($('.qd-text span.qd-teaser').length > 0){
				$('.qd-text span.qd-teaser').html(window.jstransobj.quantityDiscountDesktopText);
			}
        }
        //------------------------------------------------------------------------------------------
        if (window.innerWidth <= 767) {
            $('#continue1 span').html(window.jstransobj.continueButtonText2);
        } else {
            $('#continue1 span').html(window.jstransobj.continueButtonText1);
        }
        //trimArticleName();
    };

    kaskoInsuranceLabelsChange();
});

$('#orderStatus__coupon__show').on('click', function() {
	showCouponInput();
});

// click na logo button gre back, če je hashtag nostripes
$(function(e) {
    $( '.continue-shopping, .header .header__left' ).on('click', function(e) {
        if($(this).attr('href') == "#") {
            e.preventDefault();
            history.back();
        }
    });
});

//skrivamo in prikazujemo formo za račun na firmo
$('#showCompanyForm').on('click', function() {
	$('#vat-error-notice').hide();
	setTimeout(function() {
	    if($('#thirdStep__companyForm').css('display') == 'none') {
	        $('#thirdStep__companyForm').slideDown();
	        $('#enterBillInfoText').slideDown();

	        $('body, html').animate({
	            scrollTop: $("#enterBillInfoText").offset().top - 20
	        });
	    } else {
			resetVAT();
			clearCompanyAddress();
			resetVatInputStyles();
	        $('#thirdStep__companyForm').slideUp(function() {
	            $('#enterBillInfoText').slideUp('slow');

	            $('#thirdStep__companyForm .input__invalid').removeClass('input__invalid');
	        });
	    }
	}, 200);
});

// spreminjanje checkboxa za newsletter na koncu košarice
$('#newsletter').on('click', function() {
    var input = $('#agreement').prop('checked');

	if($('#newsletter').hasClass('loyal-customer') == true) {
		return;
	}

    if(input) {
        $('#newsletter').removeClass('thirdStep__agreement--active');
        $('#newsletter').addClass('thirdStep__agreement--passive');
        $('#agreement').prop('checked', false);
        $(this).find('.hand').show();
    } else {
        $('#newsletter').removeClass('thirdStep__agreement--passive');
        $('#newsletter').addClass('thirdStep__agreement--active');
        $('#agreement').prop('checked', true);
        $(this).find('.hand').hide();
    }
});

// animiranje passworda pri izboru na prvem koraku
$('#registered').on('click', function() {
    if(window.innerWidth > 580) {
        passwordShow("49%", true);
    }
    else {
        passwordShow("100%", false);
    }
});
//--------------------------------------------------------------------
$('#quickBuy').on('click', function() {
    if(window.innerWidth > 580) {
        passwordHide(true);
    }
    else {
        passwordHide(false);
    }
});
//--------------------------------------------------------------------


//-----------------------END------------------------------------------
//---------animiranje informacije za CVV------------------------------
// $('#creditCard__tooltip').mouseover(function() {
//     $('#creditCard__tooltip__info').stop().fadeIn();
// }).mouseout(function() {
//     $('#creditCard__tooltip__info').stop().fadeOut();
// });

//------PREKLOP IZ PRVEGA KORAKA NA DRUGEGA---------------------------
//
//enter key

$('#firstStep__email input').on('keypress', function(e) {
    if(e.which == 13) {
        if($('.firstStep__inner').css('display') != 'none') {
            $('#continue1').click();
        }
    }
});



$('.firstStep__title').on('click', function () {
    if ($('.secondStep__inner').css('display') != 'none') {
        checkoutStepUncomplete(1);
        secondToFirst();
    } else {
        checkoutStepUncomplete(1);
        checkoutStepUncomplete(2);
        thirdToFirst();
    }
});

$('.secondStep__title').on('click', function() {
    // thirdToSecond();
    // checkoutStepUncomplete(2);
    if($('.firstStep__inner').css('display') == 'none') {
        checkoutStepUncomplete(2);
        thirdToSecond();
    }
    else {
        $('#continue1').click();
    }
});

$('.thirdStep__title').on('click', function() {
    if($('.firstStep__inner').css('display') == 'none') {
        $('#continue2').click();
    }
});

$('#continue1').on('click', function() {
    if(!window.jstransobj) {
        window.jstransobj = { linkPrefix : "" };
    }

	var email = $.trim($('#firstStep__email input').val());
	if(email == "") {
        alert(jstransobj.enterEmailNotice);
        return;
	} else {

		if( !validateEmail(email) ) {
			$('#firstStep__email input').removeClass('input__valid').addClass('input__invalid');
			asyncalert(jstransobj.emailFormatError);
			return;
		} else {
			$('#firstStep__email input').removeClass('input__invalid').addClass('input__valid');
		}

	    var obj = {
	        email: email,
	        linkCart: true
	    };

        var cartId = getCookie('cart');

        $.ajax({
            cache: false,
            url: jstransobj.linkPrefix + '/customer/add',
            method: 'POST',
            data: obj,
            success: function (data) {
                if(data == 'true') {
				}
                sibPush(cartId);
			}
		});

		sendinblueIdentifyPush(email);
		klaviyoIdentifyPush(email);
		$('#thirdStep__user__email input').val(email);
		firstToSecond();
		revalidateCoupon();
		rebuildGifts();
	}
});

// $('#continue1').on('click', function() {
//     if(!window.jstransobj) {
//         window.jstransobj = { linkPrefix : "" };
//     }
//     if(GIZZMO.__blockimpatience) { return; }
//     var email = $('#firstStep__email').find('input').val();
//     var obj = {
//         email: email,
//         linkCart: true
//     };
//     var invoker = this;
//
//     if(email === "") {
//         alert(jstransobj.enterEmailNotice);
//         return;
//     }
//     else {
//         if (/^\S+@\S+\.\S+$/.test(email)) {
//             deactivateButton.call(invoker);
//             $.ajax({
//                 cache: false,
//                 url: jstransobj.linkPrefix + '/customer/add',
//                 method: 'POST',
//                 data: obj,
//                 success: function (data) {
//                     if(data == 'true') {
//                         $('#remove-after-first-step').remove();
//                         updateMailerLite(email);
//                         deactivateButton.call($('.secondStep__continue')[0]);
//                         GIZZMO.__blockimpatience = 0;
//                         //naredimo ajax klic, da posodobimo poštnino
//                         $('#changeMethod').click();
//                         resetPostage();
//                         getShippingCosts();
//
//                         $('#thirdStep__user__email').find('input').val(email);
//                         $('#ssl_notice').css('display','none');
//                         $('#help_notice').css('display','block');
//
//                         firstToSecond();
//                         $('.firstStep__title').css('cursor','pointer');
//                         setTimeout(function() {
//                             activateButton.call(invoker);
//                             $(".meter > span").width('34%');
//                         }, 2000);
//
//                         $('a.faq').addClass('show-on-second');
//                     }
//                     else if(data === 'false') {
//                         activateButton.call(invoker);
//                         alert(jstransobj.error);
//                         return;
//                     }
//                 },
//                 error: function (data) {
//                     activateButton.call(invoker);
//                     alert(jstransobj.serverError);
//                     if (typeof _errs == 'object') {
//                         _errs.push(new Error(data.responseText));
//                     }
//                     return;
//                 }
//             });
//         }
//         else {
//             activateButton.call(invoker);
//             alert(jstransobj.emailFormatError);
//             return;
//         }
//     }
// });

//--------------------------------------------------------------------
//------PREKLOP IZ DRUGEGA KORAKA NA TRETJEGA-------------------------
$('#continue2').on('click', function() {
    var invoker = this;

    if(GIZZMO.__isStockFalse) {
        alert(jstransobj.someProductsNotAvailable);
        $('html, body').animate({
            scrollTop: $(".secondStep").offset().top
        }, 800);
        highlightStockIssues();
        return;
    }

    if($('#cart__countries').length) {
        if($('#paymentMethods').css('display') == 'none' ) {
            asyncalert(jstransobj.noCountrySelectedError);
            return;
        }
    }

    var osebniPrevzem = false;
    var placilnaMetoda = false;
    $.each($('#pickStore').find('input'), function() {
        if($(this).prop('checked')) {
            osebniPrevzem = true;
            return;
        }
    });
    $.each($('.cart__pMethods__wrapper').find('input'), function() {
        if($(this).prop('checked')) {
            placilnaMetoda = true;
            return;
        }
    });

    if($('.cart__header__right').hasClass('cart__header--active') && !osebniPrevzem) {
        asyncalert(jstransobj.pickupLocationPickError);
        highlightPaymentMethodSelector();
        return;
    }

    if(!placilnaMetoda) {
        asyncalert(jstransobj.paymentMethodPickError);
        highlightPaymentMethodSelector();
        return;
    }

    if($('.cart__pMethods__pp').find('input').prop('checked') && !window.GIZZMO.__nonce) {
        asyncalert(jstransobj.noPaypalConnection);
        highlightPaymentMethodSelector();
        return;
    }

    if($('.cart__pMethods__klarna').find('input').prop('checked')){
    	// if(!window.GIZZMO.__klarna.status){
		// 	if(window.GIZZMO.__klarna.init){
		// 		asyncalert(jstransobj.klarnaWait);
		// 	}else{
		// 		asyncalert(jstransobj.klarnaSessionError);
		// 		highlightPaymentMethodSelector();
		// 	}
		//
		// 	return;
		// }

    	$('.klarna').show();
	}else{
		$('.klarna').hide();
	}
    //------------------------------------------------//
    secondToThird();
    /* Update bottom notice with final pay price */
    updateBottomOrderInfo();

	if($('#vat_country').val().toString().toUpperCase() == "SI") {
		updateFormTexts();
	}

    $(".meter > span").width('88%');
});


window.__customCounter = 0;
window.__zapierPush = 1;
$('#continue3').on('click', function() {
	window.__customCounter++;

	if(window.GIZZMO.__globalPostage.billing === 'klarna'){
		authKlarna(function(data){
			if(data.status === true && data.data.approved === true){
				window.GIZZMO.__klarna.authorization_token = data.data.authorization_token;
				processOrder();
			}
		});

		return;
	}

	if(window.GIZZMO.__globalPostage.billing === 'leanpay'){
		setWaveCookie("_up_offer_unlocked", 1, (1/48));
	}

	if(window.__customCounter >= 4) {
		if (typeof _errs == 'object') {
			var objForm = validateForms();
			var products = "";

            $('#cart_product_summary_table .table__cell__articleRemove').each(function() {
                products += $(this).data('productid') + ",";
            });

			objForm.products = products;

			_errs.push(new Error("Stranka kliknila zadnji gumb več kot 3x ~ " + objForm.customer.name + JSON.stringify(objForm) + "," + getCookie("cart") + "," + GIZZMO.__waitinitialization + "," + GIZZMO.__blockimpatience +  "~"));
			if(window.__zapierPush) {
				window.__zapierPush = 0;
				$.ajax ({
					url: 'https://hooks.zapier.com/hooks/catch/919965/ei5odn/',
					data: objForm,
					method: 'POST',
					cache: false
				});
			}
		}
	}

	if( $.trim($('#userEmail').val()) == "" ) {
		asyncalert(jstransobj.enterEmailCheckoutNotice);
		$('#userEmail').addClass('input__invalid');
		return;
	}
	else {
		$('#userEmail').removeClass('input__invalid').addClass('input__valid');
		if( validateEmail($.trim($('#userEmail').val())) ) {
			$('#userEmail').removeClass('input__invalid').addClass('input__valid');
		}
		else {
			asyncalert(jstransobj.emailFormatError);
			$('#userEmail').removeClass('input__valid').addClass('input__invalid');
			return;
		}
	}


	if(["pickupbox_ce", "pickupbox_lj"].indexOf(window.GIZZMO.__globalPostage.shipping) !== -1) {
		validatePhoneNumberAndProcessOrder(true);
	} else {
		processOrder();
	}

});

function requestLeanpayApiKey(objForm){
	var name = objForm.customer.fname;
	var lastName = objForm.customer.lname;
	var vendorApiKey = "85691728-96b1-44f6-b16a-e21a08835b9e";
	var vendorTransactionId = "test12345";
	var amount = 200;
	var successUrl = 'https://local.gizzmo.si/thankyou';
	var errorUrl = 'https://local.gizzmo.si/thankyou';
	
	var orderData = {
		"vendorApiKey": vendorApiKey,
		"vendorTransactionId": vendorTransactionId,
		"amount": amount,
		"successUrl": successUrl,
		"errorUrl": errorUrl,
		"vendorFirstName": name,
		"vendorLastName": lastName,
		"CartItems": {
			"name": "Product Name",
			"sku": "sku",
			"price": amount,
			"qty": 1,
			"lpProdCode": "product_code"
		}
	}

	$.ajax({
        url: jstransobj.linkPrefix + '/order/leanpay/token',
        method: 'POST',
        data: orderData,
		cache: false,
        success: function(response) {
            if (response.status === 'success') {
				alert(response);
                window.location.href = response.redirectUrl;
            } else {
                asyncalert(response.error);
                finishButtonContinueActivate();
            }
        },
        error: function() {
            asyncalert('Error requesting Leanpay token.');
            finishButtonContinueActivate();
        }
    });


}


function validatePhoneNumberAndProcessOrder(process_order) {
	if(GIZZMO.__phoneNumberValidationAjax !== null) {
		GIZZMO.__phoneNumberValidationAjax.abort();
	}

	finishButtonContinueDeactive();
	$('#phone_loading_icon').show();
	GIZZMO.__phoneNumberValidationAjax = $.ajax({
		url: jstransobj.linkPrefix + '/cart/validate/phone',
		method: 'POST',
		data: {'phone': $('#userGsm').val()},
		cache: false,
		success: function (response) {
			if(response.status == false) {
				$('#userGsm').removeClass('input__valid').addClass('input__invalid');
				alert(window.jstransobj.incorrectPhoneNumber);
			} else {
				$('#userGsm').removeClass('input__invalid').addClass('input__valid');

				if(process_order === true) {
					processOrder();
				}
			}
		},
		error: function (response) {
			alert(jstransobj.errorValidatingPhoneNumber);
			if (typeof _errs == 'object') {
				_errs.push(new Error("Error validating phone number: " + response.responseText));
			}
		},
		complete: function() {
			GIZZMO.__phoneNumberValidationAjax = null;
			$('#phone_loading_icon').hide();
			if(process_order !== true) {
				finishButtonContinueActivate();
			}
		}
	});
}

//če smo na INTERNATIONAL potem poteženo to funkcijo, drugače ne
if($('#cart__countries').length > 0) {
    if(!window.jstransobj) {
        window.jstransobj = { linkPrefix : "" };
    }
    $.ajax({
        url: jstransobj.linkPrefix + '/cart/getShippingCountries',
        method: 'POST',
        cache: false,
        success: function (data) {
            if (data.length != 0) {
                //console.log(data);
                $("#cart__countries").autocomplete({
                    source: function(req, responseFn) {
                        var re = $.ui.autocomplete.escapeRegex(req.term);
                        var matcher = new RegExp( "^" + re, "i" );
                        var a = $.grep( data, function(item, index){
                            return matcher.test(item.label);
                        });
                        responseFn( a );
                    },
                    focus: function (event, ui) {
                        $("#cart__countries").val(ui.item.label);
                        $("#cart__countries").removeClass($("#cart__countries").attr('flagclass'));
                        $("#cart__countries").attr('flagclass', ui.item.class);
                        $("#cart__countries").addClass(ui.item.class);

                        return false;
                    },
                    select: function (event, ui) {
                        getShippingCosts({'shipping_country':ui.item.id});
                        window.GIZZMO.__isInternational = ui.item.id;
                        if($('.cart__pMethods__wrapper').children().hasClass('scaleOut')) {
                            changePaymentMethod();
                        }
                        setTimeout(function() {
                           $('#paymentMethods').slideDown();
                           // $('.cart__int').css('border-bottom','none');
                        },250); // malenkost zamika, da ajax klic opravi svoje
                        return false;
                    },
                    messages: {
                        noResults: '',
                        results: function() {}
                    }
                });
            } else {
                alert(jstransobj.error);
            }
        },
        error: function (message) {
            alert(jstransobj.error);
            if (typeof _errs == 'object') {
                _errs.push(new Error(data.responseText));
            }
        }
    });
}


$('#orderStatus__coupon').parent().find('input').on('keypress', function(e) {
    if(e.which == 13) {
        $('#orderStatus__coupon').click();
    }
});

//---------animiranje kupona pri avtentikaciji------------------------
$('#orderStatus__coupon').on('click', function(event) {
    if(GIZZMO.__ajax_active === null) {
		$(this).parent().children('input').addClass('orderStatus__couponStatus__input__glow');

		toggleLoadingAnimation("tables_wrapper", []);
		toggleLoadingAnimation("giftWrapper");

        GIZZMO.__ajax_active = true;
		applyCouponAjax();
    }
});

$('#removeCoupon').on('click', function() {
    if(GIZZMO.__ajax_active === null) {
		$('#orderStatus__coupon').parent().children('input').addClass('orderStatus__couponStatus__input__glow');
		toggleLoadingAnimation("tables_wrapper", []);
		toggleLoadingAnimation("giftWrapper");
        GIZZMO.__ajax_active = true;
        $.ajax({
            url: jstransobj.linkPrefix + '/coupon/add',
            method: 'POST',
            cache: false,
            data: { 'code' : '', 'remove' : true },
            success: function (data) {
            },
            error: function(data) {
            },
			complete: function(data) {
				$('#orderStatus__coupon').parent().children('input').removeClass('orderStatus__couponStatus__input__glow');
				$('#orderStatus__couponStatus__input').data('coupon', "");
				$('#secondStepCouponNotice').parent().hide();
				refreshCart();
			}
        });
    }
});

$('#thirdStep__user__email').focusout(function(e) {
    var obj = {
        email: $.trim( e.target.value ),
        linkCart: true
    };
    if(obj.email != "") {
        addCustomer(obj);
		sendinblueIdentifyPush(obj.email);
		klaviyoIdentifyPush(obj.email);
    }
});

/* City autofill */
var allowedCityAutofillLocales = ['si', 'hr', 'hu', 'cz'];
if(allowedCityAutofillLocales.indexOf(window.jstransobj.locale) >= 0){
	$('#thirdStep__userForm #userPostalcode').focusout(function(e) {
		var postalCode = $.trim( e.target.value );

		if(postalCode !== "") {
			$('#thirdStep__userForm #userCityhall').prop('disabled', true);
			__enableLoader('.input__cityhall');
			$.ajax({
				cache: false,
				url: jstransobj.linkPrefix + '/cart/city/autofill?postalCode=' + postalCode,
				method: 'GET',
				success: function (data) {
					var cityHall = $('#thirdStep__userForm #userCityhall');
					var cityHallLabel = $('#thirdStep__userForm .input__cityhall .input__placeholder');

					if(data.status && data.data !== null){
						if(data.dataCount === 1 ){
							cityHall.val(data.data);
							cityHall.addClass('input__valid');
							cityHall.css('padding-top', '20px');

							cityHallLabel.css('display', 'inline-block');
							cityHallLabel.css('opacity', '1');
						}else{
							cityHall.autocomplete({
								source: data.data,
								autoFocus: true,
								autoSelect: true,
								minLength: 0
							}).focus(function () {
								cityHall.autocomplete( "search", "" );
							});
							cityHall.autocomplete( "widget" ).addClass('city-autocomplete');
							cityHall.css('padding-top', '20px');
							cityHallLabel.css('display', 'inline-block');
							cityHallLabel.css('opacity', '1');
						}
					}
					$('#thirdStep__userForm #userCityhall').prop('disabled', false);
					__disableLoader('.input__cityhall');
					$('#thirdStep__userForm #userCityhall').focus();
				},
				error: function (data) {
					$('#thirdStep__userForm #userCityhall').prop('disabled', false);
					__disableLoader('.input__cityhall');
				}
			});
		}
	});
}

$(function() {
    var oexpire = getCookie("oexpire");

    if(!oexpire) {
        var date = Date.now() + 480 * 1000;
        setWaveCookie("oexpire", date, (1/48));
    }

    if (document.getElementById("expireOrder")) {
        if (getCookie("oexpire") < Date.now()) {
            document.getElementById("expireOrder").innerHTML = window.jstransobj.orderExpiredText;
        } else {
            initializeExpireOrder("expireOrder", getCookie("oexpire"));
        }
    }
});


//----------------------------------------------------------------------
//$(document).ready(function() {
    //preklicemo ročno nastavljanje checkboxa, saj bomo to počeli programersko
$('[prevent-default]').on('click', function(event) {
    event.preventDefault();
    event.stopPropagation();
    return false;
});

//funkcija za spremembo dostave ali osebnega prevzema levo
$('.cart__header__left').on('click', function() { // če je aktivno, ne počnemo nič se vrnemo
	if (isDoubleClicked(this)) return;

    if($(this).hasClass('cart__header--active')) {
		changePaymentMethod();
		return;
	}

	$('.cart__payment-christmas-notice').show();

	/* Revert -> CC & PP switch text for pickup */
	var ccPaymentText = $('.cart__pMethods__cc .cart__pMethods__title span');
	if(typeof ccPaymentText != "undefined"){
		var paymentText = ccPaymentText.data('text');
		if(paymentText){
			ccPaymentText.text(paymentText);
		}
	}
	var ppPaymentText = $('.cart__pMethods__pp .cart__pMethods__title span');
	if(typeof ppPaymentText != "undefined"){
		var prepaymentText = ppPaymentText.data('text');
		if(prepaymentText){
			ppPaymentText.text(prepaymentText);
		}
	}

	var $first_row_priority = $('.additional-service.first-row-priroity');
	if($first_row_priority.length) {
		$first_row_priority.removeClass('hidden');
	}

	var $premium_insurance = $('.additional-service.premium-insurance');
	if($premium_insurance.length) {
		$premium_insurance.removeClass('hidden');
	}

	var $eco_packaging = $('.additional-service.eco-packaging');
	if($eco_packaging.length) {
		$eco_packaging.removeClass('hidden');
	}

	GIZZMO.__paymentMethodWrapperHeight = "auto";
	$('.shipping-cost-free').hide();
	$('.shipping-cost-pay').show();

    $(this).toggleClass('cart__header--active');
    $('.cart__header__right').removeClass('cart__header--active');
	$('.cart__header__end').removeClass('cart__header--active');
	$('.cart__turboShipping').slideUp(function() {});
    $('.cart__pickStore').slideUp(function() {
        $('.cart__pMethods__header').slideUp(400);
		changePaymentMethod("showPaymentMethods");
    });

	resetPickupMethod();
	resetTurboMethod();

    //nastavljanje globalnega parametra poštnine
    window.GIZZMO.__globalPostage.shipping = "delivery";
    //moramo preveriti, če je prejšnja metoda slučajno prevzem, ker s tem spremenimo billing v COD
    if(window.GIZZMO.__globalPostage.billing == 'pay_ce' || window.GIZZMO.__globalPostage.billing == 'pay_lj') {
        window.GIZZMO.__globalPostage.billing = 'cod';
    }
    //nastavitev atributa za pravilno posodobitev poštnine ob izboru po povzetju
    $('.cart__pMethods__prevzem').find('input').attr('billing', 'cod');
    $('.cart__pMethods__prevzem').find('.shipping-cost-pay span').attr('cod', "");

    $('#paymentMethods').slideDown();
    $('.cart__pMethods__prevzem').find('.cart__pMethods__title span').html(jstransobj.perPostText);

	setTimeout(function() {
		updateModulePostages(window.GIZZMO.__globalPostage.shipping);
	}, 500);

    //popravimo poštnino na košarici, če že z izbrano plačilno metodo menja prevzem
    if($('.cart__pMethods__wrapper div.select').hasClass('scaleOut')) { // varovalka, če uporabnik prehitro klikne 2 metodi
        /*console.log({'shipping':window.GIZZMO.__globalPostage.shipping,'billing':window.GIZZMO.__globalPostage.billing,'shipping_country':'null'});*/
        updatePostage({'shipping':window.GIZZMO.__globalPostage.shipping,'billing':window.GIZZMO.__globalPostage.billing,'shipping_country': window.GIZZMO.__isInternational != -1? window.GIZZMO.__isInternational : 'null'}); // preverimo če je multisite,da pošljemo id od site-a
    }

	if($('#vat_country').val().toString().toUpperCase() == "SI") {
		$('.input__address, .input__postalcode, .input__cityhall').show();
	}
});
//----------------------------------------------------------------------

//funkcija za spremembo dostave ali osebnega prevzema desno
$('.cart__header__right').on('click', function() {
	if (isDoubleClicked(this)) return;
    if($(this).hasClass('cart__header--active')) { return; } // če je aktivno, ne počnemo nič se vrnemo

	GIZZMO.__paymentMethodWrapperHeight = "auto";
	$('.shipping-cost-free').show();
	$('.shipping-cost-pay').hide();
	$('.cart__payment-christmas-notice').show();

	/* CC & PP switch text for pickup */
	var ccPaymentText = $('.cart__pMethods__cc .cart__pMethods__title span');
	if(typeof ccPaymentText != "undefined"){
		var prepaymentText = ccPaymentText.data('text-prepayment');
		if(prepaymentText){
			ccPaymentText.text(prepaymentText);
		}
	}
	var ppPaymentText = $('.cart__pMethods__pp .cart__pMethods__title span');
	if(typeof ppPaymentText != "undefined"){
		var prepaymentText = ppPaymentText.data('text-prepayment');
		if(prepaymentText){
			ppPaymentText.text(prepaymentText);
		}
	}

	var $first_row_priority = $('.additional-service.first-row-priroity');
	if($first_row_priority.length) {
		if($first_row_priority.hasClass('selected')) {
			$first_row_priority.find('input').prop('checked', !$first_row_priority.find('input').prop('checked'));
			$first_row_priority.find('input').trigger('change');
		}
		$first_row_priority.addClass('hidden');
	}

	var $premium_insurance = $('.additional-service.premium-insurance');
	if($premium_insurance.length) {
		if($premium_insurance.hasClass('selected')) {
			$premium_insurance.find('input').prop('checked', !$premium_insurance.find('input').prop('checked'));
			$premium_insurance.find('input').trigger('change');
		}
		$premium_insurance.addClass('hidden');
	}

	var $eco_packaging = $('.additional-service.eco-packaging');
	if($eco_packaging.length) {
		if($eco_packaging.hasClass('selected')) {
			$eco_packaging.find('input').prop('checked', !$eco_packaging.find('input').prop('checked'));
			$eco_packaging.find('input').trigger('change');
		}
		$eco_packaging.addClass('hidden');
	}

    $(this).toggleClass("cart__header--active");
    $('.cart__header__left').removeClass('cart__header--active');
	$('.cart__header__end').removeClass('cart__header--active');
    $('.cart__pMethods__header').slideDown();
    $('.cart__pickStore').slideDown();
	$('.cart__turboShipping').slideUp(function() {});
    $('#paymentMethods').slideUp();

	if($('.cart__pickStore .cart__store').length == 1){
		setTimeout(function(){
			$('.cart__pickStore .cart__store')[0].click();
		}, 500);
	}

	changePaymentMethod();
	resetTurboMethod();

	if($('#vat_country').val().toString().toUpperCase() == "SI") {
		$('.input__address, .input__postalcode, .input__cityhall').hide();
	}
});

//funkcija za spremembo dostave ali osebnega prevzema fast shipping
$('.cart__header__end').on('click', function() {
	if (isDoubleClicked(this)) return;
	if($(this).hasClass('cart__header--active')) { return; } // če je aktivno, ne počnemo nič se vrnemo

	GIZZMO.__paymentMethodWrapperHeight = "auto";
	$('.shipping-cost-free').hide();
	$('.shipping-cost-pay').show();
	$('.cart__payment-christmas-notice').show();

	var $first_row_priority = $('.additional-service.first-row-priroity');
	if($first_row_priority.length) {
		if($first_row_priority.hasClass('selected')) {
			$first_row_priority.find('input').prop('checked', !$first_row_priority.find('input').prop('checked'));
			$first_row_priority.find('input').trigger('change');
		}
		$first_row_priority.addClass('hidden');
	}

	$(this).toggleClass("cart__header--active");
	$('.cart__header__left').removeClass('cart__header--active');
	$('.cart__header__right').removeClass('cart__header--active');
	$('.cart__pMethods__header').slideDown();
	$('.cart__turboShipping').slideDown();
	$('.cart__pickStore').slideUp();
	$('#paymentMethods').slideUp();

	changePaymentMethod();
	resetPickupMethod();

	if($('#vat_country').val().toString().toUpperCase() == "SI") {
		$('.input__address, .input__postalcode, .input__cityhall').show();
	}
});

// del zgornje funkcije, ki samo obarva background in vzporedno nastavljamo vrednosti inputom, ter animiramo izbor, ter višino containerja
$('#pickStore').on('click', 'div.select', function() {
	if (isDoubleClicked(this)) return;

    var children = $(this).parent().children(); // lokacije prevzema kot objekt
	if($(this).hasClass('cart__store--disabled')) { return; }

    if(children.hasClass('scaleOut')) { // varovalka, če uporabnik prehitro klikne 2 metodi
		GIZZMO.__paymentMethodWrapperHeight = "auto";
		changePaymentMethod("hidePaymentMethods");
		changePickupMethod();
        return;
    }

    // funkcija pri izboru lokacije osebnega prevzema
	var attrType = $(this).attr('type');

    $('#paymentMethods').slideDown();
    $('.cart__pMethods__prevzem').find('.cart__pMethods__title span').html(jstransobj.pickupPostageText);

    //nastavljanje globalnega parametra poštnine
    window.GIZZMO.__globalPostage.billing = $(this).find('input').attr('billing');
    window.GIZZMO.__globalPostage.shipping = $(this).find('input').attr('shipping');
	if(typeof window.GIZZMO.__globalPostage.billing != 'undefined' && window.GIZZMO.__globalPostage.billing != '') {
	    $('.cart__pMethods__prevzem').find('.shipping-cost-pay span').attr(window.GIZZMO.__globalPostage.billing,"");
	    $('.cart__pMethods__prevzem').find('input').attr('billing', window.GIZZMO.__globalPostage.billing);
	}
    updateModulePostages(window.GIZZMO.__globalPostage.shipping);

    gtmServiceCheckoutStepsPush(2,window.GIZZMO.__globalPostage.shipping); // datalayer push

    var length = children.length;
    var index = parseInt($(this).attr('multiplier'));
    var initialHeight = $('#pickStore').outerHeight();
    var reduceHeight = $(this).outerHeight()*(length-1);
    var moveUp = $(this).outerHeight()*index;
    GIZZMO.__storeWrapperHeight = initialHeight; // shranimo si višino, da lahko v primeru spremembe nazaj animirano na pravilno začetno višino

    if(initialHeight-reduceHeight < 0) { return; } // varovalka, če še enkrat klikamo, da ne zniža višine ponovno, v teoriji sem ne smemo prit 2x vzporedno

    children.splice(index,1);
    children.addClass("scaleOut");

    $(this).stop().animate({
        bottom: moveUp
    },200);

    setTimeout(function() {
        $('#pickStore').stop().animate({
            'height': initialHeight-reduceHeight
        });
    },500);

    var children = $(this).parent().children();
    if(!children.hasClass('cart__store--active')) {
        $(this).addClass('cart__store--active');
        children.find('input').prop('checked', false);
        $(this).find('input').prop('checked', true);
    }

    //popravimo poštnino na košarici, če že z izbrano plačilno metodo menja prevzem
    if($('.cart__pMethods__wrapper div.select').hasClass('scaleOut')) { // varovalka, če uporabnik prehitro klikne 2 metodi
        updatePostage({'shipping':window.GIZZMO.__globalPostage.shipping,'billing':window.GIZZMO.__globalPostage.billing,'shipping_country': window.GIZZMO.__isInternational != -1? window.GIZZMO.__isInternational : 'null'}); // preverimo če je multisite,da pošljemo id od site-a
    }
});
/* Turbo shipping */
$('#turboShipping').on('click', 'div.select', function() {
	if (isDoubleClicked(this)) return;

	var children = $(this).parent().find('div.select'); // lokacije prevzema kot objekt
	if($(this).hasClass('cart__store--disabled')) { return; }


	if(children.hasClass('scaleOut')) { // varovalka, če uporabnik prehitro klikne 2 metodi
		GIZZMO.__paymentMethodWrapperHeight = "auto";
		changePaymentMethod("hidePaymentMethods");
		changeTurboMethod();
		return;
	}

	// funkcija pri izboru lokacije osebnega prevzema
	var attrType = $(this).attr('type');

	$('#paymentMethods').slideDown();
	$('.cart__pMethods__prevzem').find('.cart__pMethods__title span').html(jstransobj.pickupPostageText);

	//nastavljanje globalnega parametra poštnine
	window.GIZZMO.__globalPostage.billing = $(this).find('input').attr('billing');
	window.GIZZMO.__globalPostage.shipping = $(this).find('input').attr('shipping');
	if(typeof window.GIZZMO.__globalPostage.billing != 'undefined' && window.GIZZMO.__globalPostage.billing != ''){
		$('.cart__pMethods__prevzem').find('.shipping-cost-pay span').attr(window.GIZZMO.__globalPostage.billing, "");
		$('.cart__pMethods__prevzem').find('input').attr('billing', window.GIZZMO.__globalPostage.billing);
	}
	updateModulePostages(window.GIZZMO.__globalPostage.shipping);

	gtmServiceCheckoutStepsPush(2,window.GIZZMO.__globalPostage.shipping); // datalayer push

	var length = children.length;
	var index = parseInt($(this).attr('multiplier'));
	var initialHeight = $('#pickStore').outerHeight();
	var reduceHeight = $(this).outerHeight()*(length-1);
	var moveUp = $(this).outerHeight()*index;
	GIZZMO.__storeWrapperHeight = initialHeight; // shranimo si višino, da lahko v primeru spremembe nazaj animirano na pravilno začetno višino

	if(initialHeight-reduceHeight < 0) { return; } // varovalka, če še enkrat klikamo, da ne zniža višine ponovno, v teoriji sem ne smemo prit 2x vzporedno

	if($('#turboShipping').find('.cart__turbo-notice').length) {
		GIZZMO.__turboNoticeHeight = $('#turboShipping').find('.cart__turbo-notice')[0].scrollHeight;
	}
	$('.cart__turbo-notice').hide();

	children.splice(index,1);
	children.addClass("scaleOut");

	$(this).stop().animate({
		bottom: moveUp
	},200);

	setTimeout(function() {
		$('#turboShipping').stop().animate({
			'height': initialHeight-reduceHeight
		});
	},500);

	var children = $(this).parent().children();
	if(!children.hasClass('cart__store--active')) {
		$(this).addClass('cart__store--active');
		children.find('input').prop('checked', false);
		$(this).find('input').prop('checked', true);
	}

	//popravimo poštnino na košarici, če že z izbrano plačilno metodo menja prevzem
	if($('.cart__pMethods__wrapper div.select').hasClass('scaleOut')) { // varovalka, če uporabnik prehitro klikne 2 metodi
		updatePostage({'shipping':window.GIZZMO.__globalPostage.shipping,'billing':window.GIZZMO.__globalPostage.billing,'shipping_country': window.GIZZMO.__isInternational != -1? window.GIZZMO.__isInternational : 'null'}); // preverimo če je multisite,da pošljemo id od site-a
	}
});
    // -------------------------------

// funkcija, ki animira izbor plačilne metode in zoža po višini container
$('.cart__pMethods__wrapper').on('click', 'div.select', function() {
	if (isDoubleClicked(this)) return;

    window.GIZZMO.__globalPostage.billing = $(this).find('input').attr('billing');
    $(".meter > span").width('64%');

	$('.cart__pMethods__prevzem').addClass('no-border');
    var children = $('.cart__pMethods__wrapper div.select:visible'); // plačilne metode kot objekt
    //var children = $(this).parent().children(); // plačilne metode kot objekt

    if(children.find('input:checked').length) { // varovalka, če uporabnik prehitro klikne 2 metodi
        $('#changeMethod').fadeOut(function() {
            changePaymentMethod();
        });
        return;
    }

    $('#changeMethod').fadeIn();

    var length = children.length;
    var index = parseInt($(this).attr('multiplier'));
    var initialHeight = (length * 64) + 27;
    var reduceHeight = parseInt($(this).outerHeight()*(length-1));
    var moveUp = parseInt($(this).outerHeight()*index);

    GIZZMO.__paymentMethodWrapperHeight = initialHeight;

    children.splice(index,1);
    children.addClass("scaleOut");

    $(this).find('input').prop('checked', true);
    $(this).addClass('cart__pMethods--active');

    var type=$(this).attr('type');

	if(type != "prevzem") {
		$('.cart__payment-christmas-notice').fadeOut();
	}

    $(this).stop().animate({
        bottom: moveUp
    },200);

	if(type == 'klarna') {
		initKlarna();
		gtmServiceCheckoutStepsPush(2 ,"Klarna"); // datalayer push
		//GIZZMO.__waitinitialization = 0;
	}

    setTimeout(function() {
        $('.cart__pMethods__wrapper').stop().animate({
            'height': initialHeight-reduceHeight
        },250, function() {
            // ker mamo samo za paypal dodatne animacije, bomo tu vse uredili, ne delamo nove funkcije
            if(type == 'credit-card') {
                $('#changeMethod2').css('display', 'block');
                gtmServiceCheckoutStepsPush(2,"Visa"); // datalayer push
				$('.where-to-pay-info').show();
            }
            else if(type == 'paypal') {
                teardownPaypal(); // počistimo prej, da bo vedno na novo inicializiralo
                initPaypal();// inicializacija tokena
                gtmServiceCheckoutStepsPush(2,"Paypal"); // datalayer push
                $('.paypalPick').slideDown('slow');
				$('.cart__pMethods').addClass('no-border-radius');
            }
            else if(type == 'prevzem') {
                showMoneySavingNotice();
                gtmServiceCheckoutStepsPush(2,"onDelivery"); // datalayer push
                activateButton.call($('.secondStep__continue')[0]);
                GIZZMO.__waitinitialization = 0;
            }
            else if(type == 'invoice') {
                showMoneySavingNotice();
                gtmServiceCheckoutStepsPush(2,"invoice"); // datalayer push
                activateButton.call($('.secondStep__continue')[0]);
                GIZZMO.__waitinitialization = 0;
            }
			else if(type == 'stripe') {
				gtmServiceCheckoutStepsPush(2,"Visa"); // datalayer push
				$('.where-to-pay-info').show();
			}
        });
    },600);

    var object = {
        'shipping'         : window.GIZZMO.__globalPostage.shipping,
        'billing'          : window.GIZZMO.__globalPostage.billing,
        'shipping_country' : window.GIZZMO.__isInternational != -1? window.GIZZMO.__isInternational : 'null'
    };

    updatePostage(object); // preverimo če je multisite,da pošljemo id od site-a
});
//--------------------------------------------------------------------

// izbor druge plačilne metode, če se uporabniku ponesreči prvi izbor, sklop animacij, paypal in ostalo (brez cc)
$('#changeMethod').on('click', function() {
    if (isDoubleClicked(this)) return;

    $(this).fadeOut(function() {
        changePaymentMethod();
    });
});

//--------------------------------------------------------------------
// izbor druge plačilne metode, če se uporabniku ponesreči prvi izbor, CC
$('#changeMethod2').on('click', function() {
    // if(GIZZMO.__waitinitialization != 0) { return; }

    changePaymentMethod();
    thirdToSecond();
    checkoutStepUncomplete(2);
});
    //--------------------------------------------------------------------
//});
//dodan event na paypal okvir, da zaženemo
if(document.querySelector('#paypalPick')) {
    document.querySelector('#paypalPick').addEventListener('click', function (event) {
        event.preventDefault();
        if(event.target.id == 'paypalPick__cancel') {
            reinitiatePaypal();
        }
        if(!GIZZMO.__nonce) {
            if(GIZZMO.__checkout) {
                GIZZMO.__checkout.paypal.initAuthFlow();
            }
        }
    }, false);
}


//--------------------------------------------------------------------
// remove product from cart
$('body').on('click', '.table__cell__articleRemove, .table__cell__articleRemove--responsive', function() {

	if(GIZZMO.__ajax_active === null) {
		GIZZMO.__ajax_active = true;
			toggleLoadingAnimation("tables_wrapper", []);
			toggleLoadingAnimation("giftWrapper");

		var elementId = $(this).attr('data-productid');
		var cartelementId = $(this).attr('data-id');
		// s tem ko pošljemo 0 kot drugi argument, zagotovimo, da bo push v datalayer število izdelkov, ki  jih uporabnik trenutno ima (saj izbriše celoten artikel iz košarice)
		gtmServiceCartQuantityChangePush(elementId, parseInt(0), parseInt($(this).parents('.table__row').find('select').val()));
		removeArticleFromCart(cartelementId);

		if( $('[data-product-id="'+elementId+'"]').length ) {
			$('[data-product-id="'+elementId+'"]').prop('checked', false);
			$('[data-product-id="'+elementId+'"]').parent().removeClass('selected');
		}
	}

});

// change quantity

$('body').on('click', '.quantity__wrapper .arrow', function(e) {
    e.preventDefault();

    if(GIZZMO.__ajax_active === null) {
		GIZZMO.__ajax_active = true;

		toggleLoadingAnimation("tables_wrapper", []);
		toggleLoadingAnimation("giftWrapper");

		var direction = 1;
		if($(this).hasClass('bottom')) {
			direction = -1;
		}

		var qty = parseInt($(this).parents('.quantity__wrapper').find('.pick span').text()) + direction;

		if(qty <= 0) {
			removeArticleFromCart($(this).attr('data-id'));
			return;
		}

		$(this).removeClass("clicked");
		$(this)[0].offsetWidth = $(this)[0].offsetWidth;
		$(this).addClass("clicked");

		var obj = {
			id: $(this).attr('data-id'),
			qty: qty
		};

		$(this).parents('.quantity__wrapper').find('.pick span').text( qty );
		gtmServiceCartQuantityChangePush($(this).attr('data-productid'), qty, parseInt($(this).attr('previous-qty')));
		updateQuantity(obj, $(this));
		$(this).parents('.quantity__wrapper .arrow').attr('previous-qty', qty-direction);
	}
});

$('body').on('click', '.giftContainer__gift', function(event) {
    event.preventDefault();
    if( event.target.className.indexOf('giftContainer__gift__info') != -1 ) { return; }

    var element = $(this);
    if( element.hasClass("disabled") ) {
        return;
    }

    var limit = $(this).parent().data('count');
    var giftGroup = $(this).parent().data('giftgroup');

	if(GIZZMO.giftArray.length < 1){
		rebuildGifts();
	}

    if(element.hasClass("giftContainer__gift--passive")) {
		if(limit != 0) {
			if( GIZZMO.giftArray[giftGroup].length == limit ) {
				var removeGift = GIZZMO.giftArray[giftGroup].shift();
				$('#g' + removeGift ).removeClass("giftContainer__gift--active");
				$('#g' + removeGift ).addClass("giftContainer__gift--passive");
				$('#g' + removeGift ).find('input').prop('checked', false);
				GIZZMO.giftArray[giftGroup].push( $(this).data('id') );
			}
			else {
				GIZZMO.giftArray[giftGroup].push( $(this).data('id') );
			}

			element.removeClass("giftContainer__gift--passive");
			element.addClass("giftContainer__gift--active");
			element.find('input').prop('checked', true);
		}
    }
    else {
        var removeIndex = GIZZMO.giftArray[giftGroup].indexOf( $(this).data('id') );
        if ( removeIndex > -1 ) {
            GIZZMO.giftArray[giftGroup].splice(removeIndex, 1);
        }

        element.removeClass("giftContainer__gift--active");
        element.addClass("giftContainer__gift--passive");
        element.find('input').prop('checked', false);
    }

    setWaveCookie("gifts", JSON.stringify( GIZZMO.giftArray ), 1);
	updateSelectedGiftsCounter();
});

(function() {
    $('body').on('click', '.giftContainer__gift__info', function(event) {
        $(this).siblings('.giftContainer__gift__description').toggleClass('visible');
        $(this).siblings('.giftContainer__gift__image').toggleClass('giftContainer__gift__image--blur');
    });
})();


// ----- ANIMIRANJE INPUT TEXT TYPE PLACEHOLDER ----- //
$('.animate-input-label').on('keyup', function () {
    onKeyUpInputCall.call(this);
});

$('#thirdStep__userForm input, #thirdStep__companyForm input').on('focusout', function () {
    var parent = $(this).parent('div');

    if( $.trim($(this).val()) != "" ) {
        $(this).addClass('input__valid');
    }
    else {
        $(this).removeClass('input__valid');
        $(this).removeClass('input__invalid');
    }

    var input = parent.children('input');
    var placeholder = parent.children('span');

	if(["pickupbox_ce", "pickupbox_lj"].indexOf(window.GIZZMO.__globalPostage.shipping) !== -1) {
		if(input.attr('id') == "userGsm") {
			$(this).removeClass('input__valid');
	        $(this).removeClass('input__invalid');

			validatePhoneNumberAndProcessOrder(false);
		}
	}

    // omogočanje kopiranja vsebine inputa za ime in priimek v formo za firmo (samo prvič)
    if(input.attr('id') == 'userName') {
        if($('#userName').data('copy') == null) {

            $('#companyUserName').val($('#userName').val());
            $('#companyUserName').addClass('input__valid');

            if($.trim($('#userName').val()).length) {
                $('#userName').data('copy', {copy: 'false'});
            }
            onKeyUpInputCall.call($('#companyUserName'));
        }
    }
    if(input.attr('id') == 'userSurname') {
        if($('#userSurname').data('copy') == null) {

            $('#companyUserSurname').val($('#userSurname').val());
            $('#companyUserSurname').addClass('input__valid');

            if($.trim($('#userSurname').val()).length) {
                $('#userSurname').data('copy', {copy: 'false'});
            }
            onKeyUpInputCall.call($('#companyUserSurname'));
        }
    }

    // preverimo, če je prazen input, da ga animiramo nazaj
    if (input[0].value == '') {
        input.attr('placeholder', placeholder[0].innerHTML);
        placeholder.stop().animate(
                {
                    'opacity': '0'
                }, 1, function () {
            input.stop().animate(
                    {
                        'padding-top': '0px' //hack 1px
                    }
            );
        }
        );
    }
});

$('#confirm-vat').on('click', function(e) {
	e.preventDefault();

	if( !$('.thirdStep__vat_check_container').hasClass('disabled') ) {
		checkVAT();
	}
});

$('#vat_registered_checkbox').on('change', function() {
	var state = $('#vat_registered_checkbox').prop('checked');

	if(state) {
		enableVatRegistered();
	} else {
		disableVatRegistered();
		resetVAT();
	}
});

$('#countryCombobox').change(function(e) {
	$('#vat_country').val( $(this).find(':selected').val() );
});

$('#idddv').on({
    focus: function () {
        $('#vat_country').addClass('focused');
    },

    blur: function () {
        $('#vat_country').removeClass('focused');
    }
});

$('#idddv').on('keypress', function(e) {
	if(e.which == 13) {
		if(
		$('#vat_country').val().toString().toUpperCase() != "SI" &&
		$('#vat_country').val().toString().toUpperCase() != "DE") {
			$('#confirm-vat').trigger('click');
		}
	}
});

$('#vat-retry-address-check').on('click', function(e) {
	e.preventDefault();
	if (isShippingSameAsBilling() ) {
		$('#vat-error-notice').addClass('success');
		vatRegisteredShippingAddress_matchSuccess();
	}
	else {
		alert(window.jstransobj.shippingAndBillingMismatch);
		vatRegisteredShippingAddress_matchFailed();
	}
});

$('#vat-slide-to-finish').on('click', function(e) {
	e.preventDefault();
	goToFinishButton();
});

$('#vat-successfull-address-match').on('click', function() {
	goToFinishButton();
});

$('#clear-vat').on('click', function(e) {
	e.preventDefault();
	$('#vat_registered_checkbox').prop('checked', false);
	disableVatRegistered();
	resetVAT();
	$('#showCompanyForm').trigger('click');
});

$(function() {

	$('.additional-service input').change(function(e) {
		var currentState = $(this).prop('checked');
		var inputId = $(this).attr('id');

		if(inputId === 'input-product-gift-packaging' && typeof inputId !== 'undefined'){
			var giftPackagingElement =  $(this).parent().find("a.gift-packaging-selector");
			if(typeof giftPackagingElement !== 'undefined' && giftPackagingElement.length > 0){
				GIZZMO.giftPackagingElement = giftPackagingElement[0];
				GIZZMO.giftPackagingElement.click();
			}
		}else if(inputId === 'input-product-warranty' && $(this).hasClass('selector')){
			var selectorElement =  $(this).parent().find("a.gift-packaging-selector");
			if(typeof selectorElement !== 'undefined' && selectorElement.length > 0){
				GIZZMO.selectorElement = selectorElement[0];
				GIZZMO.selectorElement.click();
			}
		}else{
			if(GIZZMO.__ajax_active === null) {
				GIZZMO.__ajax_active = true;

				toggleLoadingAnimation("tables_wrapper", []);
				toggleLoadingAnimation("giftWrapper");

				var checked = $(this).prop('checked');
				var additional_service = $(this).data('additionalService');
				var productId = $(this).data('productId');
				var parentId = $(this).data('parent-product-id');
				var url = window.cart_address + jstransobj.linkPrefix + '/cart/add/' + productId + "/1";
				if(typeof parentId === "undefined"){
					parentId = null;
				}

				var data = {
					additional_service : additional_service,
					parent_product: parentId
				};
				if(checked) {
					$(this).parent().addClass('selected');
					if(additional_service === 'product_kasko_insurance') {
						url = window.cart_address + jstransobj.linkPrefix + '/cart/categorizedCrossSell/add';
						data = {
							categorized_ics: [
								{
									'product_cross': {
										'productId': $(this).data('productId'),
										'priceSource': {
											'pool': 'product_kasko_insurance',
											'categoryId': '',
											'upsellProductId': $(this).data('productId'),
											'isTwoPlusOneDiscount': false
										},
										'tag': 'checkout_reborn_ics_kasko',
										'isProductCrossSell': true,
										'parentId': parentId
									}
								}
							]
						};
					}
					$.ajax({
						url: url,
						method: 'POST',
						data: data,
						cache: false,
						xhrFields: {
							withCredentials: true
						},
						success: function (data) {
							refreshCart();
						},
						error: function (data) {
							if (typeof _errs == 'object') {
								_errs.push(new Error(data.responseText));
							}
						},
						complete: function() {
						}
					});
				}
				else {
					if(inputId !== 'input-product-warranty'){
						$(this).parent().removeClass('selected');
					}
					
					var cartelementId = $('[data-productid="'+ productId +'"]').data('id');
					removeArticleFromCart(cartelementId);
				}
			}
			else {
				$(this).prop('checked', !currentState);
			}
		}

	});
});

$('body').on('click', '.close-notice-btn', function(e) {
	e.preventDefault();
	$(this).parent().fadeOut(200);
});

/**
 * Klarna selector
 */
$(function() {
	$('.klarna').on('click', '.klarna-payment', function (e){
		var thisElement = $(this);
		if(thisElement.hasClass('active')){ return; }

		$('.klarna-payment.active').each(function (){
			$(this).find('.klarna_selector_content').slideUp(100);
			$(this).removeClass('active');
		});

		setTimeout(function () {
			thisElement.addClass('active');
			thisElement.find('.klarna_selector_content').slideDown(100);
		}, 100);
	});
});

/**
 * Quantity discount
 */
$(function() {
	$('body').on('click', '.qd-bar', function (e){
		if($(this).hasClass('disabled')){
			return;
		}
		$(this).addClass('disabled');

		toggleLoadingAnimation("tables_wrapper", []);
		toggleLoadingAnimation("giftWrapper");

		var platform = window.innerWidth < 786 ? "mobile" : "desktop";
				
		var quantity = parseInt($(this).attr('data-qty'));
		if(typeof quantity !== "undefined"){
			var newQty = quantity + 1;
			var howMany = newQty == 2 ? "2" : "3";

			var obj = {
				id: $(this).attr('data-id'),
				qty: newQty,
				tag: platform + "_checkout_" + howMany
			};
			gtmServiceCartQuantityChangePush($(this).attr('data-productid'), newQty, quantity);
			updateQuantity(obj, $(this));
		}
	});
});

/**
 * Inline product warranty 
 */
 $(function() {
	$('body').on('click', '.warranty-bar', function (e){
		if($(this).hasClass('disabled')){
			return;
		}
		$(this).addClass('disabled');

		toggleLoadingAnimation("tables_wrapper", []);
		toggleLoadingAnimation("giftWrapper");

		var productId = $(this).data('product-id');
		var parentId = $(this).data('parent-product-id');

		$.ajax({
			url: window.cart_address + jstransobj.linkPrefix + '/cart/add/' + productId + "/1",
			method: 'POST',
			data: { additional_service : 'product_warranty', parent_product: parentId },
			cache: false,
			xhrFields: {
				withCredentials: true
			},
			success: function (data) {
				refreshCart();
			},
			error: function (data) {
				if (typeof _errs == 'object') {
					_errs.push(new Error(data.responseText));
				}
			},
			complete: function() {
			}
		});
	});
});

/**
 * Christmas surprise
 */
$(function() {
	$('body').on('click', '.christmas_add', function (e){
		e.preventDefault();
		if($(this).hasClass('disabled')){
			return;
		}
		$(this).addClass('disabled');

		var productId = $(this).attr('data-product-id');

		if(typeof productId !== 'undefined'){
			var url = window.cart_address + jstransobj.linkPrefix + '/cart/add/' + productId + "/1?product_surprise=true";
			$.ajax({
				url: url,
				method: 'POST',
				cache: false,
				xhrFields: {
					withCredentials: true
				},
				success: function (data) {
					if(data === "true") {

						$('#christmas_surprise_si').addClass('added');
						var thankyouElement = $('.christmas_surprise_thankyou');
						if(typeof thankyouElement !== 'undefined'){

							setTimeout(function(){
								$('.christmas_surprise_block').slideUp(400);
								thankyouElement.fadeIn(400);
							}, 100);

						}else{
							alert(window.jstransobj.christmasSurpriseSuccess);
						}
						/* Mystery BOX */
						$('#mystery_box_product').addClass('added');
						var thankyouElement = $('.mystery_box_product .thankyou_block');
						if(typeof thankyouElement !== 'undefined'){
							setTimeout(function(){
								$('.mystery_box_product .mystery_box_block').slideUp(400);
								thankyouElement.fadeIn(400);
							}, 100);
						}else{
							alert(window.jstransobj.christmasSurpriseSuccess);
						}
					}
				},
				error: function (data) {
					if (typeof _errs == 'object') {
						_errs.push(new Error(data.responseText));
					}
				},
				complete: function() {
					updateBottomOrderInfo();
					refreshCart();
					$('.christmas_add').removeClass('disabled');
				}
			});
		}
	});

	$('body').on('click', '.christmas_surprise_thankyou .remove-product', function (e){
		e.preventDefault();
		if($(this).hasClass('disabled')){
			return;
		}
		$(this).addClass('disabled');

		var productId = $(this).attr('data-id');

		if(typeof productId !== 'undefined' && productId != ""){
			removeArticleFromCart(productId);
			$(this).removeClass('disabled');
			$(this).attr('data-id', '');
			$('.christmas_surprise_si').removeClass('added');
			$('.mystery_box_product').removeClass('added');
		}else{
			$(this).removeClass('disabled');
		}
	});

});

/**
 * Gift packaging
 */
(function (root, document) {
	"use strict";

	var timeoutNumber = 0;

	if (typeof IframeLightbox === 'undefined') {
		timeoutNumber = 2000;
	}

	setTimeout(function(){
		if (typeof IframeLightbox !== 'undefined') {
			[].forEach.call(document.getElementsByClassName("gift-packaging-selector"), function (el) {
				el.lightbox = new IframeLightbox(el, {
					onCreated: function () {
					},
					onLoaded: function () {
					},
					onError: function () {
					},
					onClosed: function () {
						refreshCart();
					},
					scrolling: true, /* default: false */
					rate: 200 /* default: 500 */
				});
			});
		}
	}, timeoutNumber);

})("undefined" !== typeof window ? window : this, document);

$('.gift-packaging-container').on('click', '.product-wrapper .product', function (e) {
	var parentElement = $(this).find('.mark');

	if(parentElement.hasClass('selected')){
		parentElement.removeClass('selected');
		parentElement.find('input[type="checkbox"]').prop("checked", false);
	}else{
		/*checkGiftPackagingProducts();*/
		parentElement.addClass('selected');
		parentElement.find('input[type="checkbox"]').prop("checked", true);
	}
});

function checkGiftPackagingProducts(){
	var limit = 3;
	var checkedProducts = $('.gift-packaging-container .mark input[type="checkbox"]:checked').length;
	if(checkedProducts >= limit){
		var firstElement = $('.gift-packaging-container .mark input[type="checkbox"]:checked').first();
		firstElement.prop("checked", false);
		firstElement.parent().removeClass('selected');
	}
}

function getGiftPackagingProductArray(){
	var products = {};
	$('.gift-packaging-container .mark input[type="checkbox"]:checked').each(function () {
		var pid = $(this).attr('data-product-id');
		products[pid] = $(this).val();
	});

	return products;
}

function closeGiftPackagingFrame(){
	if(typeof GIZZMO.giftPackagingElement !== 'undefined' && GIZZMO.giftPackagingElement !== null){
		GIZZMO.giftPackagingElement.lightbox.close();
	}
	if(typeof GIZZMO.selectorElement !== 'undefined' && GIZZMO.selectorElement !== null){
		GIZZMO.selectorElement.lightbox.close();
	}
}

$('.gift-packaging-container').on('click', '.selector .option', function (e) {
	$('.gift-packaging-container .selector .option.selected').removeClass('selected');
	$(this).addClass('selected');
});

$('.gift-packaging-container').on('click', '.gift-packaging-save', function (e) {
	var packagingProduct = $('.gift-packaging-container .selector .option.selected');
	var products = getGiftPackagingProductArray();

	if(typeof packagingProduct === 'undefined'){
		alert('Please select gift packaging');
	}else{
		var productId = packagingProduct.attr('data-product-id');
		if(typeof productId !== 'undefined'){

			var url = window.cart_address + jstransobj.linkPrefix + '/cart/add/' + productId + "/1";
			$.ajax({
				url: url,
				method: 'POST',
				data: {gift_packaging:true, connected_products: JSON.stringify(products)},
				cache: false,
				xhrFields: {
					withCredentials: true
				},
				success: function (data) {
					window.parent.closeGiftPackagingFrame();
				},
				error: function (data) {
					if (typeof _errs == 'object') {
						_errs.push(new Error(data.responseText));
					}
				},
				complete: function() {
				}
			});
		}
	}
});

function getWarrantyProductArray(){
	var products = {};
	$('.gift-packaging-container .mark input[type="checkbox"]').each(function () {
		var productId = $(this).data('product-id');
		var parentId = $(this).data('parent-product-id');
		var productCartId = $(this).attr('data-cart-id');
		products[parentId] = {
			'pid': productId,
			'parentId': parentId,
			'cartId': productCartId,
			'selected': $(this).is(':checked')
		};
	});

	return products;
}

$('.gift-packaging-container').on('click', '.warranty-save', function (e) {
	var products = getWarrantyProductArray();
	toggleLoadingAnimation("product-wrapper");

	var url = window.cart_address + jstransobj.linkPrefix + '/cart/warranty/add';
	$.ajax({
		url: url,
		method: 'POST',
		data: {warrantyProducts: JSON.stringify(products)},
		cache: false,
		xhrFields: {
			withCredentials: true
		},
		success: function (data) {
			refreshCart();
			toggleLoadingAnimation("product-wrapper");
			window.parent.closeGiftPackagingFrame();
		},
		error: function (data) {
			toggleLoadingAnimation("product-wrapper");
			if (typeof _errs == 'object') {
				_errs.push(new Error(data.responseText));
			}
		}
	});
});

$('.button-close').click(function (e) {
	window.parent.closeGiftPackagingFrame();
});

/* Lottie - Christmas surprise */
function loadLottieScript(){
	if(GIZZMO.__lottie === true){
		return;
	}

	var christmasElement = $('.christmas_surprise_si');
	if(typeof christmasElement !== 'undefined'){
		var script = document.createElement('script');
		script.onload = function () {
			GIZZMO.__lottie = true;
			lottieLoaded();
		};
		/*script.src = 'https://cdnjs.cloudflare.com/ajax/libs/bodymovin/5.7.5/lottie.min.js';
		script.src = 'https://cdnjs.cloudflare.com/ajax/libs/bodymovin/5.7.8/lottie_light.min.js';*/
		script.src = 'https://cdnjs.cloudflare.com/ajax/libs/bodymovin/5.7.8/lottie_light_html.min.js';

		document.head.appendChild(script);
	}

}

function lottieLoaded(){
	var christmasElement = $('.christmas_surprise_si');
	if(typeof christmasElement !== 'undefined'){
		if(christmasElement.hasClass('humanitarian')){
			var animationDesktop = bodymovin.loadAnimation({
				container: document.getElementById('christmas_surprise_svg_desktop'),
				path: '/shared/cart/json/DariloP-21_WEB.json',
				renderer: 'svg',
				loop: true,
				autoplay: true,
			});
			var animationMobile = bodymovin.loadAnimation({
				container: document.getElementById('christmas_surprise_svg_mobile'),
				path: '/shared/cart/json/DariloP-21_MOBILE.json',
				renderer: 'svg',
				loop: true,
				autoplay: true,
			});
			var animationDesktopThankyou = bodymovin.loadAnimation({
				container: document.getElementById('christmas_surprise_svg_desktop_thankyou'),
				path: '/shared/cart/json/data_si_desktop_ty.json',
				renderer: 'svg',
				loop: true,
				autoplay: true,
			});
			var animationMobileThankyou = bodymovin.loadAnimation({
				container: document.getElementById('christmas_surprise_svg_mobile_thankyou'),
				path: '/shared/cart/json/data_si_mobile_ty.json',
				renderer: 'svg',
				loop: true,
				autoplay: true,
			});
		}else{
			var animationDesktop = bodymovin.loadAnimation({
				container: document.getElementById('christmas_surprise_svg_desktop'),
				path: '/shared/cart/json/gift_surprise_desktop.json',
				renderer: 'svg',
				loop: true,
				autoplay: true,
			});
			var animationMobile = bodymovin.loadAnimation({
				container: document.getElementById('christmas_surprise_svg_mobile'),
				path: '/shared/cart/json/gift_surprise_mobile.json',
				renderer: 'svg',
				loop: true,
				autoplay: true,
			});
		}
	}
}
$(function() {
	$('.slide-down-button').on('click', function (){
		if($(this).hasClass('open')){
			$(this).removeClass('open');
			$('.slide-down-content').slideUp(200);
		}else{
			$(this).addClass('open');
			$('.slide-down-content').slideDown(200);
		}
	});
});

$('.cart__turbo-notice').on('click', function(event) {
	$('.turbo-shipping-regions').fadeIn();
	$('.turbo-shipping-regions').toggleClass('closed');
});

$('.turbo-shipping-regions').on('click', function(event) {
	if(!$('.turbo-shipping-regions').hasClass('closed')) {
		$('.turbo-shipping-regions').fadeOut();
		$('.turbo-shipping-regions').toggleClass('closed');
	}
});

/**
 * Synthesia
 */
$('body').on('click', 'div.synthesia_close', function (){
	$('.synthesia').remove();
});

/* run site coupon countdown if the markup exists */
(function() {
	var minutesSpan = document.getElementById('scnMinutes');
	var secondsSpan = document.getElementById('scnSeconds');
	var siteCoupoNotice = document.getElementById('site-coupon-notice');
	var scnProgressBar = document.getElementById('scnProgressBar');
	var activeText = document.getElementById('active-text');
	// var activeText2 = document.getElementById('active-text-2');
	var expiredText = document.getElementById('expired-text');
	var reactivatingText = document.getElementById('reactivating-text');
	var reactivatedText = document.getElementById('reactivated-text');
	var width = 0;
	var animate = false;
	var timerInterval;

	if(siteCoupoNotice) {
		var endTime = siteCoupoNotice.getAttribute('data-time');
		var firstUse = siteCoupoNotice.getAttribute('data-first-use')
		var activateButton = document.getElementById('activate');

		activateButton.addEventListener('click', function(e) {
			reactivateCoupon();
		});

		function reactivateCoupon(firstUse) {

			if(typeof firstUse == "undefined") {
				firstUse = false;
			}

			if(!firstUse) {
				var redirectTo = window.location.pathname;
				if(window.location.search == "") {
					redirectTo += "?coupon=" + siteCoupoNotice.getAttribute('data-coupon');
				} else {
					redirectTo += window.location.search + "&coupon=" + siteCoupoNotice.getAttribute('data-coupon');
				}
				window.location = redirectTo;
				return false;
			}

			expiredText.style.display = "none";
			reactivatingText.style.display = "block";
			scnProgressBar.style.width = "100%";
			setTimeout(function() {
				reactivatingText.style.display = "none";
				reactivatedText.style.display = "block";
				setTimeout(function() {
					if(firstUse) {
						setTimeout(function(){
							activeText.style.display = "block";
							expiredText.style.display = "none";
							reactivatedText.style.display = "none";
							scnProgressBar.classList.remove('delay');
							updateScnTimer();
							timerInterval = setInterval(updateScnTimer, 1000);
						},2000);
					}
				}, 200);
			}, 3000);
		}

		function updateScnTimer() {
			var t = getTimeRemaining(endTime);

			if (t.total <= 0) {
				$.ajax({
					url: jstransobj.linkPrefix + '/coupon/add',
					method: 'POST',
					cache: false,
					data: { 'code' : '', 'remove' : true },
					success: function (data) {
					}
				});

				clearInterval(timerInterval);
				if(scnProgressBar.getAttribute('data-animate') === "true") {
					scnProgressBar.style.width = "0%";
				}
				activeText.style.display = "none";
				// activeText2 ? activeText2.style.display = "none" : '';
				expiredText.style.display = "block";
				return;
			}

			if(minutesSpan != null && secondsSpan != null){
				minutesSpan.innerHTML = t.minutes;
				secondsSpan.innerHTML = ('0' + t.seconds).slice(-2);
			}

			if(scnProgressBar.getAttribute('data-animate') === "true") {
				if(animate) {
					width = (100 * t.total) / (30 * 60 * 1000);
					scnProgressBar.style.width = width.toFixed(2) + "%";
				}
			}
		}

		if(firstUse == "true") {
			reactivateCoupon(firstUse);
			// registerEvents();
			$.post( jstransobj.linkPrefix + '/coupon/update-animation-flag?v='+Math.random(), { 'flag' : 'coupon_first_use' } );
		} else {
			scnProgressBar.classList.remove('delay');
			updateScnTimer();
			var timerInterval = setInterval(updateScnTimer, 1000);
			// registerEvents();
		}

		setTimeout(function() {
			animate = true;
		}, 1000);
	}
})();

$('.userCommentForDeliveryServiceWrapper a.expand').click(function(event) {
	event.preventDefault();

	if($('.userCommentWrapper').data('isOpen') == 'yes') {
		$('.userCommentWrapper').slideUp(function() {
			$('.userCommentWrapper').data('isOpen', 'no');
		});
	} else {
		$('.userCommentWrapper').slideDown(function() {
			$('#userComment').focus();
			$('.userCommentWrapper').data('isOpen', 'yes');
		});
	}
});

$('#userCommentForDeliveryService').on('keydown', updateCharacterLengthForDeliveryService);
$('#userCommentForDeliveryService').on('keyup', updateCharacterLengthForDeliveryService);

function updateCharacterLengthForDeliveryService() {
	var max = 35;
	var length = $('#userCommentForDeliveryService').val().length;
	if(length > max) {
		$('#userCommentForDeliveryService').val($('#userCommentForDeliveryService').val().substring(0,max));
		length = $('#userCommentForDeliveryService').val().length;
	}
	$('.userCommentForDeliveryServiceWrapper .max-character-counter').text(length+"/35");
	if(length >= 30) {
		$('.userCommentForDeliveryServiceWrapper .max-character-counter').css('color', '#F03545');
	} else {
		$('.userCommentForDeliveryServiceWrapper .max-character-counter').css('color', '#5c5c5c');
	}
}

(function ( $ ) {

    $.fn.isInViewport = function( offset ) {
        if($(this).offset()) {
            if(typeof offset === "undefined") {
                offset = 0;
            }
            var elementTop = $(this).offset().top + offset;
            var elementBottom = elementTop + $(this).outerHeight();
            var viewportTop = $(window).scrollTop();
            var viewportBottom = viewportTop + $(window).height();
            return elementBottom > viewportTop && elementTop < viewportBottom;
        }
    };

}( jQuery ));

function displayProductRating() {
    $('.checkout-cross-sell.product').each(function (index, element) {
        var productId = $(this).data('productId');
        var $listingProduct = $(this);
        
        if($listingProduct.isInViewport(150)) {
            if(typeof productId != "undefined") {
                if($listingProduct.data('requestCreated') != 'yes') {
                    $listingProduct.data('requestCreated', 'yes');
                    $.ajax({
                        type: "GET",
                        url: window.jstransobj.linkPrefix + "/product/rating/" + $(this).data('productId'),
                        success: function (response) {
        
                            if(response.rateCount != 0) {                        
                                $listingProduct.find('.midcat-starRating-lazy').data('rating', response.avgRate);
                                $listingProduct.find('.product-votes').html(response.rateCount);
        
                                $listingProduct.find('.midcat-starRating-lazy').starRating({
                                    initialRating:$(this).data('score'),
                                    strokeColor: '#f2f2f2',
                                    strokeWidth: 10,
                                    starSize: 18,
                                    useGradient: false,
                                    emptyColor: '#f2f2f2',
                                    hoverColor: '#ffd969',
                                    activeColor: '#ffd969',
                                    readOnly: true
                                });
        
                                if($listingProduct.find('.based-on').length) {
                                    $listingProduct.find('.based-on').text($listingProduct.find('.based-on').data('text').replace('%number%', response.rateCount));
                                }

                                if($listingProduct.find('.product-midcat').length) {
                                    $listingProduct
                                        .find('.product-midcat')
                                        .fadeOut(function() {
                                            $listingProduct.find('.ratings--lazyloaded').fadeIn();
                                        });                                
                                } else {
                                    $listingProduct.find('.ratings--lazyloaded').fadeIn().css('opacity', '1');
                                }
                            } else {
                                $listingProduct.find('.ratings--lazyloaded').slideUp();
                            }
                        }
                    });
                }
            }
        }        
    });
}

window.addEventListener('load', function() {
    window.addEventListener('scroll', function(e) {
        displayProductRating();
    });
    displayProductRating();
});

(function($) {
	var canMakeRequest = true;

	$('.checkout-cross-sell.product .atc-button').click(function(e) {

		var $button = $(this);
		var $productContainer = $(this).parents('.product');
		var productId = $productContainer.data('productId');
		var quantity = $(this).data('quantity') ? $(this).data('quantity') : 1;
		var data = {
			checkout_cross : {
				'isCheckoutCrossSell': false,
				'productType': 'checkout_cross',
				'tag': $productContainer.data('tag')
			}
		};

		if($.trim($productContainer.data('priceSource')) != "") {
			data['checkout_cross']['priceSource'] = $productContainer.data('priceSource');
			data['checkout_cross']['isCheckoutCrossSell'] = true;
		}
	
		if(canMakeRequest) {
			canMakeRequest = false;
			toggleLoadingAnimation($productContainer.attr('id'),[]);
	
			$.ajax({
				url: window.cart_address + jstransobj.linkPrefix + '/cart/add/' + productId + "/" + quantity,
				method: 'POST',
				data: data,
				success: function (data) {
					refreshCart();
				},
				complete: function() {
					setTimeout(function() {
						$button.find('.add-special-offer').text($button.find('.add-special-offer').data('moreText'));
						canMakeRequest = true;
						toggleLoadingAnimation($productContainer.attr('id'),[]);
						$('body, html').animate({
							'scrollTop': $('#tables_wrapper').offset().top - 100
						});
					}, 1000);

					$button.parents('.checkout-cross-sell.product').find('.atc-button').data('quantity', '');
				}
			});	
		}
	});

}(jQuery));

function loadKaskoSalesCount() {
	if(!window.jstransobj) {
		window.jstransobj = { linkPrefix : "" };
	}
	
	$.ajax({
		url: jstransobj.linkPrefix + '/cart/kasko-sales-count',
		method: 'GET',
		cache: false,
		success: function(data) {
			if(data.success && data.count > 0) {
				var $countElement = $('.kasko-label-24-count');
				if($countElement.length > 0) {
					$countElement.text(data.count + 'x');
				}
			}
		},
		error: function(data) {
			console.log('Failed to load Kasko sales count');
		}
	});
}

loadKaskoSalesCount();

function initiateLightbox() {
	[].forEach.call(document.getElementsByClassName("quickview-lightbox"), function (el) {
		el.lightbox = new IframeLightbox(el, {
			onCreated: function () {
			},
			onLoaded: function () {
				resizeQuickViewIframe();

				if (document.querySelector('#reamaze-widget-icon')) {
					document.querySelector('#reamaze-widget-icon').style.display = "none";
				}
			},
			onError: function () {
			},
			onClosed: function () {
				if (document.querySelector('#reamaze-widget-icon')) {
					document.querySelector('#reamaze-widget-icon').style.display = "inherit";
				}
			},
			scrolling: false, /* default: false */
			rate: 1 /* default: 500 */
		});
	});
}
initiateLightbox();

function resizeQuickViewIframe() {
    var iframe = document.querySelector('.iframe-lightbox iframe');
    if(iframe) {		
		var iframe = document.querySelector('.iframe-lightbox iframe');
		document.querySelector('.iframe-lightbox .content').style.paddingBottom = 0;
		document.querySelector('.iframe-lightbox').classList.add('quickview');

		if(iframe.contentWindow.document.body.scrollHeight < window.innerHeight) {
			document.querySelector('.iframe-lightbox .content').style.height = iframe.contentWindow.document.body.scrollHeight + 5 + "px";                        
		} else {
			iframe.setAttribute('scrolling', 'yes');

			if(window.innerWidth < 768) {
				document.querySelector('.iframe-lightbox .content').style.height = window.innerHeight - 104 + "px";
			} else {
				document.querySelector('.iframe-lightbox .content').style.height = window.innerHeight - 200 + "px";
			}
		}
    }
}

window.addEventListener("message", function(event) {
    if(typeof event.data == "string") {
        if(event.data.indexOf("dataSource") !== -1 && event.data.indexOf("quickview")) {
            if(JSON.parse(event.data).trigger == "checkout_cross") {
				addCrossSellFromQuickview(JSON.parse(event.data));
            }
			if(JSON.parse(event.data).trigger == "upsell") {
				addCrossSellFromUpsellQuickview(JSON.parse(event.data));
			}
			if(JSON.parse(event.data).trigger === "extra_checkout_cross") {
				var eventData = JSON.parse(event.data);
				$(".iframe-lightbox .backdrop").trigger("click");
				var productId = eventData.productId;
				$(".extra-offer-on-finish #extra_cross_" + productId + " .button").trigger("click");
			}
        }
		if(event.data.indexOf("resizeQuickViewIframe") !== -1) {
			resizeQuickViewIframe();
		}
    }
}, false);

/**
 * Secret box
 */
function loadSecretBox(){
	var secretBoxElement = document.getElementsByClassName("secret-box-selector");
	if(secretBoxElement.length > 0) {
		secretBoxElement = secretBoxElement[0];
		if(secretBoxElement.classList.contains('disabled')) {
			return;
		}
		secretBoxElement.lightbox = new IframeLightbox(secretBoxElement, {
			onClosed: function () {
				refreshCart();
			},
			scrolling: true,
			rate: 200
		});
		secretBoxElement.lightbox.el.classList.add('secret-box-selector-iframe');
		GIZZMO.secretBoxElement = secretBoxElement;
		GIZZMO.secretBoxElement.click();
	}
}
function closeSecretBox(){
	$('.secret-box-selector').addClass('disabled');
	GIZZMO.secretBoxElement.lightbox.close();
}
$(function() {
	$('body').on('click', '.secret-box--btn', function (e){
		e.preventDefault();
		if($(this).hasClass('disabled')){
			return;
		}
		$(this).addClass('disabled');

		var productId = $(this).attr('data-product-id');

		if(typeof productId !== 'undefined'){
			var platform = window.innerWidth < 786 ? "mobile" : "desktop";
			var data = {
				product : {
					'tag': 'secret_box_' + platform
				}
			};

			var url = window.cart_address + jstransobj.linkPrefix + '/cart/add/' + productId + "/1";
			$.ajax({
				url: url,
				method: 'POST',
				cache: false,
				data: data,
				xhrFields: {
					withCredentials: true
				},
				success: function (data) {},
				error: function (data) {},
				complete: function() {
					window.parent.closeSecretBox();
				}
			});
		}
	});
	$('body').on('click', '.secret-box--btn-cancel', function (e){
		window.parent.closeSecretBox();
	});
});

/*
 * Extra Checkout Cross (3rd step)
 */
(function($) {
	var canMakeRequest = true;

	$('body').on('click', '.extra-offer-on-finish .product-details .button',function(e) {

		var $button = $(this);
		var $productContainer = $(this).parents('.product-details');
		var productId = $productContainer.data('product-id');
		var levelId = $productContainer.data('level-id');
		var animationContainer = 'extra_cross_' + productId;
		var quantity = 1;
		var data = {
			checkout_cross : {
				'isCheckoutCrossSell': true,
				'productType': 'checkout_cross',
				'tag': 'extra_checkout_cross',
				'levelId': levelId,
			}
		};

		if(canMakeRequest) {
			canMakeRequest = false;
			toggleLoadingAnimation(animationContainer,[]);

			$.ajax({
				url: window.cart_address + jstransobj.linkPrefix + '/cart/add/' + productId + "/" + quantity,
				method: 'POST',
				data: data,
				success: function (data) {
					if(data == 'true'){
						$button.parents('.eg-product-body').addClass('eg-product-active');
					}
					setTimeout(function() {
						refreshCart();
					}, 500);
				},
				complete: function() {
					toggleLoadingAnimation(animationContainer,[]);
					setTimeout(function() {
						canMakeRequest = true;
					}, 500);
				}
			});
		}
	});

	$('body').on('click', '.extra-offer-on-finish .product-details .cancel', function() {
		var elementId = $(this).attr('data-product-id');
		var cartProductId = $(this).attr('data-id');

		if(cartProductId !== '' && typeof cartProductId !== 'undefined'){
			gtmServiceCartQuantityChangePush(elementId, parseInt(0), parseInt(1));
			removeArticleFromCart(cartProductId);
			$(this).attr('data-id', "");
			$(this).parents('.eg-product-body').removeClass('eg-product-active');
		}
	});

}(jQuery));